import { LOCALES } from "../constants";

const da = {
    [LOCALES.DA]: {
        //All page
    "Página não encontrada": "Siden blev ikke fundet",
        //LOGIN PAGE
        "login.Login": "Log ind",
        "login.Informe seu e-mail": "Indtast din e-mail",
        "login.E-mail inválido. Por favor, verifique":
        "Ugyldig e-mail. Kontroller venligst adressen.",
        "login.Senha": "Adgangskode",
        "login.Sua senha deve possuir no mínimo 6 caracteres":
        "Din adgangskode skal indeholde mindst 6 tegn",
        "login.Esqueci minha senha": "Jeg har glemt min adgangskode",
        "login.ENTRAR": "LOG IND",
        "login.CRIAR CONTA": "OPRET KONTO",
        "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente":
        "Login mislykkedes. Kontroller dine oplysninger, og prøv igen.",
        "login.A PLATAFORMA IOK MUDOU!": "IOK-PLATFORMEN ER BLEVET OPDATERET!",
        "login.Não exibir este aviso novamente": "Vis ikke denne meddelelse igen",
        "login.Se você já possui um cadastro na antiga plataforma, ": "Hvis du allerede har en konto på den tidligere platform, ",
        "login.clique aqui": "klik her",
        "login. para": " for at ",
        "login.migrar": "migrere ",
        "login.seus dados e aproveitar toda a experiência IOK.": "dine data og få glæde af hele IOK-oplevelsen.",
        "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Din konto er ikke blevet aktiveret. Tjek venligst din e-mail for at aktivere den.",
        "login.PLATAFORMA EM MANUTENÇÃO": "PLATFORM UNDER VEDLIGEHOLDELSE",
        "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "VI FORBEREDER DEN NYE IOK-PLATFORM, OG DEN VIL SNART VÆRE KLAR!",
        "login.Migrar Conta": "Migrer konto",
        "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Hvis du allerede har en konto på den tidligere platform, skal du klikke på Migrer konto for at overføre dine data og få glæde af hele IOK-oplevelsen.",
        "login.Política de privacidade": "Privatlivspolitik",
        "login.ENTENDI": "JEG FORSTÅR",
        "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "For at forbedre din oplevelse på platformen og tilbyde personlige tjenester bruger vi cookies.",
        "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Ved at bruge IOK-platformen accepterer du automatisk brugen af cookies.",
        "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Forkert adgangskode! Du har to forsøg tilbage, før adgangen til din konto bliver blokeret.",
        "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Forkert adgangskode! Du har ét forsøg tilbage, før adgangen til din konto bliver blokeret.",
        "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "Adgang blokeret! Følg instruktionerne for kontogendannelse.",
        
        // REGISTER
        "DISTRIBUIDOR": "DISTRIBUTØR:Jeg er distributør af Prática-udstyr.",
        "REDE": "NETVÆRK:Jeg er ejer af et netværk.",
        "DONO": "VIRKSOMHED:Jeg har min egen virksomhed/er en del af et netværk.",
        "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Angiv den e-mail, der var registreret på den tidligere IOK-platform",
        "register.E-mail inválido. Por favor, verifique": "Ugyldig e-mail. Kontroller venligst.",
        "register.BUSCAR DADOS": "HENT DATA",
        "register.Nome da organização": "Organisationens navn",
        "register.Informe o nome de sua organização": "Angiv navnet på din organisation",
        "register.O campo nome da organização é obrigatório": "Feltet organisationsnavn er obligatorisk",
        "register.Este nome já existe. Por favor, escolha outro": "Dette navn findes allerede. Vælg venligst et andet.",
        "register.RECUPERAR CONTA": "GENDAN KONTO",
        "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA DE USUÁRIO. POR GENTILIZA, AGUARDE": "ORGANISATIONENS ADMINISTRATOR VIL MODTAGE EN E-MAIL FOR AT AKTIVERE DIN BRUGERKONTO. VENT VENLIGST.",
        "register.E-mail não encontrado": "E-mail blev ikke fundet",
        "register.Digite seu e-mail da plataforma IOK antiga": "Indtast din e-mail fra den tidligere IOK-platform",
        "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "Det var ikke muligt at gendanne din konto. Kontroller dine oplysninger, og prøv igen.",
        "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "Det var ikke muligt at hente dine data. Kontroller oplysningerne, og prøv igen.",
        "register.PROSSEGUIR": "FORTSÆT",
        "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO:": "DU ANMODER OM ADGANG TIL ORGANISATIONEN:",
        "register.COM O ADMINISTRADOR:": " MED ADMINISTRATOREN:",
        "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "E-mailen er allerede registreret på platformen. Angiv en ny e-mail, eller log ind med den allerede registrerede e-mail.",
        "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "Virksomheden er allerede registreret på platformen. Angiv venligst navnet på en ny virksomhed.",
        "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "DU GENKENDTE IKKE BRUGEREN {userName} SOM EN DEL AF DIN ORGANISATION, OG DERFOR BLEV VEDKOMMENDES KONTO SLETTET.",
        "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "DET VAR IKKE MULIGT AT SLETTE BRUGEREN {userName}. PRØV VENLIGST IGEN SENERE.",
        "register.CONFIRMAR": "BEKRÆFT",
        "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente" : "Det var ikke muligt at registrere dig. Kontroller dine oplysninger, og prøv igen.",
        "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR":
        "DU VIL MODTAGE EN E-MAIL FOR AT FULDFØRE DIN REGISTRERING OG AKTIVERE DIN ADMINISTRATORKONTO",
        "register.Nome": "Navn",
        "register.Informe seu nome": "Angiv dit navn",
        "register.O campo nome é obrigatório": "Navnefeltet er obligatorisk",
        "register.E-mail": "E-mail",
        "register.Informe seu e-mail": "Angiv din e-mail",
        "register.E-mail inválido. Por favor, verifique novamente":
        "Ugyldig e-mail. Kontroller venligst igen.",
        "register.Telefone": "Telefon",
        "register.Informe seu telefone": "Angiv dit telefonnummer",
        "register.Crie sua senha": "Opret din adgangskode",
        "register.Informe sua senha": "Angiv din adgangskode",
        "register.O campo senha deve conter no mínimo 6 caracteres":
        "Adgangskodefeltet skal indeholde mindst 6 tegn",
        "register.Confirme sua senha": "Bekræft din adgangskode",
        "register.As senhas devem ser iguais": "Adgangskoderne skal være identiske",
        "register.CRIAR CONTA": "OPRET KONTO",
        "register.CONTA ATIVADA COM SUCESSO": "KONTOEN ER AKTIVERET",
        "register.ACESSAR": "FÅ ADGANG",
        "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA":
        "DET VAR IKKE MULIGT AT AKTIVERE DIN KONTO",
        "register.Digite seu telefone": "Indtast dit telefonnummer",
        "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "VENT VENLIGST, MENS VI OVERFØRER DINE DATA. DENNE PROCES BØR TAGE ET PAR MINUTTER. HVIS DU HAR EN STOR MÆNGDE DATA, KAN OVERFØRSLEN TAGE OP TIL EN TIME.",
        "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "DATA ER OVERFØRT MED SUCCES! KLIK PÅ KNAPPEN NEDENFOR FOR AT FÅ ADGANG TIL PLATFORMEN.",
        "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "UGYLDIG E-MAIL. KONTROLLER VENLIGST, OM DIN KONTO ALLEREDE ER AKTIVERET.",
        "register.Ainda não tenho uma organização. Criar": "Jeg har endnu ikke en organisation. Opret",
        "register.Informe o ID da organização": "Angiv organisationens ID",
        "register.O campo com ID é obrigatório": "ID-feltet er obligatorisk",
        "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "ORGANISATIONENS ADMINISTRATOR VIL MODTAGE EN E-MAIL FOR AT AKTIVERE DIN KONTO. VENT VENLIGST.",
        "register.A nova plataforma IOK agora está dividida em organizações e possui diferentes tipos de conta, que ajudam a organizar melhor as grandes corporações, empresas e redes.": "Den nye IOK-platform er nu opdelt i organisationer og har forskellige kontotyper, som hjælper med at organisere store koncerner, virksomheder og netværk bedre.",
        "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "Administratoren af min organisation har allerede migreret kontoen, og vi har et ID. Jeg ønsker at migrere mine brugerdata.",
        "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Jeg ønsker at migrere min organisations konto og blive administrator.",
        "register.Conta da organização já migrada": "Organisationens konto er allerede migreret",
        "register.Migrar conta da organização": "Migrer organisationens konto",
        "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "Den nye IOK-platform har nu nye adgangsformer, som afhænger af den type organisation, du er en del af. Den ansvarlige for din organisation skal migrere virksomhedens hovedkonto og blive administrator, mens de øvrige medarbejdere skal knytte sig til den ved hjælp af det angivne ID.",
        "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "Det angivne ID svarer ikke til nogen virksomhed. Kontroller det, og prøv igen.",
        "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "DU HAR FOR MANGE MENUER. VI KUNNE IKKE GENNEMFØRE DEN AUTOMATISKE IMPORT. DIN KONTO VIL BLIVE AKTIVERET, MEN MENUERNE SKAL MIGRERES MANUELT.",
        "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "FOR AT MIGRERE DINE MENUER SKAL DU EFTER LOGIN KLIKKE PÅ DIT NAVN ØVERST TIL HØJRE, DEREFTER PÅ REDIGER KONTO OG TIL SIDST PÅ IMPORTER MENUER.",
        "register.Atenção:": "Bemærk:",
        "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "Kun én person i organisationen kan oprette kontoen og, efter at have aktiveret den, invitere virksomhedens øvrige brugere til at få adgang til den.",
        "register.TOKEN DESENVOLVEDOR CANCELADO": "UDVIKLERTOKEN ANNULLERET",
        "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "Din adgangskode skal være mellem 8 og 20 tegn lang og indeholde et stort bogstav, et lille bogstav, et tal og et specialtegn",
        
        //HOME
        "home.Menus disponíveis na plataforma": "Menuer tilgængelige på platformen",
        "home.Criados na plataforma": "Oprettet på platformen",
        "home.Recebidos dos fornos": "Modtaget fra ovnene",
        "home.Equipamentos vinculados": "Tilknyttede udstyr",
        "home.Total de receitas cadastradas": "Samlet antal registrerede opskrifter",
        "home.Receitas": "Opskrifter",
        "home.Receitas em menus": "Opskrifter i menuer",
        "home.Em menus": "I menuer",
        "home.Receitas salvas no Cookbook": "Opskrifter gemt i Cookbook",
        "home.No Cookbook": "I Cookbook",
        "home.Atualizações": "Opdateringer",
        "home.Copa": "Copa",
        "home.Rocket": "Rocket",
        "home.Single Mag": "Single Mag",
        "home.Versão instalada": "Installeret version",
        "home.Versão disponível": "Tilgængelig version",
        "home.Usuários cadastrados": "Registrerede brugere",
        "home.Aceitação pendente": "Afventer godkendelse",
        "home.Atualizado": "Opdateret",
        "home.OLÁ": "HEJ",
        "home.É muito bom ter você aqui!": "Det er dejligt at have dig her!",
        "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "Med IOK-platformen kan du administrere dine ovne, uanset hvor du er, oprette og administrere opskrifter og menuer, lave sikkerhedskopier, analysere data fra dit udstyr og meget mere!",
        "home.Conheça a plataforma": "Lær platformen at kende",
        "home.Taxa de erro por modelo": "Fejlrate pr. model",
        "home.Erro": "Fejl",
        "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "VI VIL GERNE HØRE DIN MENING OM",
        "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "Vi værdsætter din mening højt, og derfor har vi oprettet denne tilfredshedsundersøgelse om {model}-platformen!",
        "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "Vi værdsætter din mening højt, og derfor har vi oprettet denne tilfredshedsundersøgelse om {model}-serien!",
        "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Dine svar vil hjælpe os med at forbedre vores tjenester, så vi fortsat kan give dig den bedst mulige oplevelse.",
        "home.Reserve uns minutinhos de seu dia e participe!": "Tag et par minutter af din dag og deltag!",
        "home.Responder a pesquisa": "Besvar undersøgelsen",
        "home.Modelos em evidência": "Fremhævede modeller",
        "home.Modelos": "Modeller",
        "home.Total de equipamentos vinculados": "Samlet antal tilknyttede enheder",
        "home.Total de equipamentos online": "Samlet antal enheder online",
        "home.Equipamentos online": "Enheder online",
        "home.Países com Prática": "Lande med Prática",
        "home.Países": "Lande",
        "home.Aguarde enquanto carregamos os dados": "Vent venligst, mens vi indlæser dataene",
        "home.Quase lá! Aguarde um pouco mais": "Næsten færdig! Vent lidt endnu",
        "home.Vendas por Equipamento": "Salg pr. udstyr",
        "home.Total de equipamentos vendidos": "Samlet antal solgte enheder",
        "home.Equipamentos vendidos": "Solgte enheder",
        "home.Clique para atualizar o software": "Klik for at opdatere softwaren",
        "home.Aceitação de software pendente": "Afventer godkendelse af software",
        "home.Software atualizado": "Software opdateret",
        "home.NENHUM EQUIPAMENTO VINCULADO": "INGEN ENHEDER TILKNYTTET",
        "home.FORNOS LIGADOS": "OVNE TÆNDT",
        "home.Enviando dados": "Sender data",
        "home.Com conectividade IOK": "Med IOK-forbindelse",
        "home.Sem envio de dados": "Sender ikke data",
        "home.Sem conectividade IOK": "Uden IOK-forbindelse",
        "home.Criados na Plataforma": "Oprettet på platformen",
        "home.Apenas no Cookbook": "Kun i Cookbook",
        "home.Usuários na companhia": "Brugere i virksomheden",
        "home.Inativos": "Inaktive",
        "home.Online": "Online",
        "home.Atualizações de equipamentos": "Udstyrsopdateringer",
        "home.Modelos de equipamentos": "Udstyrsmodeller",
        "home.Atualizados": "Opdaterede",
        "home.Aguardando Aceite": "Afventer godkendelse",
        "home.Desatualizados": "Forældede",
        
        //MAIN
        "main.HOME": "HJEM",
        "main.COOKBOOK": "COOKBOOK",
        "main.MEUS MENUS": "MINE MENUER",
        "main.EQUIPAMENTOS": "UDSTYR",
        "main.USUÁRIOS": "BRUGERE",
        "main.ATENDIMENTOS": "SUPPORTSAGER",
        "main.Idioma": "Sprog",
        "main.Editar conta": "Rediger konto",
        "main.Configurações": "Indstillinger",
        "main.Sair": "Log ud",
        "main.Configurações salvas com sucesso!": "Indstillingerne er gemt!",
        "main.SALVAR": "GEM",
        "main.CONFIGURAÇÕES": "INDSTILLINGER",
        "main.Tema dark": "Mørkt tema",
        "main.Notificações": "Notifikationer",
        "main.Informações para as receitas": "Oplysninger til opskrifter",
        "main.Peso:": "Vægt:",
        "main.Gramas": "Gram",
        "main.Oz": "Oz",
        "main.Temperatura:": "Temperatur:",
        "main.Fahrenheit (°F)": "Fahrenheit (°F)",
        "main.Conta editada com sucesso!": "Kontoen er opdateret!",
        "main.EDITAR CONTA": "REDIGER KONTO",
        "main.Nome": "Navn",
        "main.Preencha com o seu nome": "Indtast dit navn",
        "main.Telefone": "Telefon",
        "main.Preencha com o seu telefone": "Indtast dit telefonnummer",
        "main.E-mail": "E-mail",
        "main.Preencha com o seu e-mail": "Indtast din e-mail",
        "main.Alterar Senha": "Skift adgangskode",
        "main.ALTERAR SENHA": "SKIFT ADGANGSKODE",
        "main.Senha atual": "Nuværende adgangskode",
        "main.Nova senha": "Ny adgangskode",
        "main.Confirmar nova senha": "Bekræft ny adgangskode",
        "main.Informe sua senha atual": "Indtast din nuværende adgangskode",
        "main.O campo senha deve conter no mínimo 6 caracteres":
        "Adgangskodefeltet skal indeholde mindst 6 tegn",
        "main.Informe sua nova senha": "Indtast din nye adgangskode",
        "main.Confirme sua nova senha": "Bekræft din nye adgangskode",
        "main.Sua nova senha deve conter no mínimo 6 caracteres":
        "Din nye adgangskode skal indeholde mindst 6 tegn",
        "main.INFORME SUA SENHA": "INDTAST DIN ADGANGSKODE",
        "main.Informe sua senha para realizar a alteração de e-mail da plataforma:":
        "Indtast din adgangskode for at ændre platformens e-mailadresse:",
        "main.CONFIRMAR": "BEKRÆFT",
        "main.Existem campos que não foram preenchidos corretamente":
        "Der er felter, som ikke er udfyldt korrekt",
        "main.Informe sua senha para prosseguir com a alteração de e-mail":
        "Indtast din adgangskode for at fortsætte med ændringen af e-mailadressen",
        "main.Senha alterada com sucesso": "Adgangskoden er ændret",
        "main.Informe sua senha atual corretamente": "Indtast din nuværende adgangskode korrekt",
        "main.As senhas devem ser iguais": "Adgangskoderne skal være identiske",
        "main.Nome do novo tipo de usuário": "Navn på den nye brugertype",
        "main.Dê um nome para o novo tipo de usuário": "Giv den nye brugertype et navn",
        "main.Token Desenvolvedor": "Udviklertoken",
        "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "Udviklertokenet er en unik og ikke-overdragelig kode, der gør det muligt at foretage ændringer på udviklingsniveau direkte i platformens kode via eksterne API'er. De gør det muligt at tilpasse platformen, så den bedre opfylder din virksomheds behov.",
        "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "Det anbefales, at disse ændringer udføres af en fagperson inden for IT.",
        "main.Para acessar o token, informe sua senha": "Indtast din adgangskode for at få adgang til tokenet",
        "main.Copie e cole o token na autenticação de todas as requisições.": "Kopiér og indsæt tokenet i godkendelsen af alle forespørgsler.",
        "main.Seu Token": "Dit token",
        "main.Token copiado com sucesso!": "Token kopieret!",
        "main.Você deseja cancelar o preenchimento das informações?": "Ønsker du at annullere udfyldelsen af oplysningerne?",
        "main.Rever tutoriais": "Gennemse vejledninger igen",
        "main.Tutoriais resetados com sucesso!": "Vejledningerne er nulstillet!",
        "main.review.tutorials": "Ønsker du at gennemgå vejledningerne til IOK-platformen igen?",
        "main.Procurar": "Søg",
        "main.review.manual": "Du kan også gemme den på din computer.",
        "main.review.download": "Åbn manual",
        
        //MEUS MENUS
        "menus.Procurar menu": "Søg efter menu eller bruger",
        "menus.Procurar menu excluído": "Søg efter slettet menu",
        "menus.Menus": "Menuer",
        "menus.Lixeira": "Papirkurv",
        "menus.CRIAR MENU": "OPRET MENU",
        "menus.IMPORTAR MENU": "IMPORTER MENU",
        "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.":
        "Filerne opbevares i papirkurven i 30 dage fra sletningsdatoen. Efter denne periode slettes de permanent.",
        "menus.VOLTAR": "tilbage",
        "menus.Compatível com: ": "Kompatibel med: ",
        "menus.Última atualização: ": "Seneste opdatering: ",
        "menus.EXPORTAR MENU": "EKSPORTER MENU",
        "menus.EDITAR MENU": "REDIGER MENU",
        "menus.Equipamentos associados": "Tilknyttede enheder",
        "menus.Grupos": "Grupper",
        "menus.Procurar grupo": "Søg efter gruppe",
        "menus.CRIAR GRUPO": "OPRET GRUPPE",
        "menus.receitas": "opskrifter",
        "menus.Nenhum grupo cadastrado": "Ingen grupper registreret",
        "menus.Nenhum menu cadastrado": "Ingen menuer registreret",
        "menus.Nome": "Navn",
        "menus.Modelo": "Model",
        "menus.Atividade": "Aktivitet",
        "menus.Associação": "Tilknytning",
        "menus.Exportar": "Eksporter",
        "menus.Editar": "Rediger",
        "menus.Excluir": "Slet",
        "menus.Equips": "Enheder",
        "menus.Receitas": "Opskrifter",
        "menus.Compatibilidade": "Kompatibilitet",
        "menus.Última atualização": "Seneste opdatering",
        "menus.Versão": "Version",
        "menus.Origem": "Oprindelse",
        "menus.Excluído por": "Slettet af",
        "menus.Data de exclusão": "Sletningsdato",
        "menus.Restaurar": "Gendan",
        "menus.Existem campos que não foram preenchidos":
        "Der er felter, som ikke er udfyldt",
        "menus.Menu criado com sucesso!": "Menu oprettet!",
        "menus.Existem campos com informações inválidas":
        "Der er felter med ugyldige oplysninger",
        "menus.SALVAR": "GEM",
        "menus.CANCELAR": "ANNULLER",
        "menus.Nome do menu": "Menunavn",
        "menus.Informe o nome do menu": "Angiv menunavnet",
        "menus.Preencha o nome do menu sem caracteres especiais": "Indtast menunavnet uden specialtegn",
        "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Kun tegnene @#%&*-+()!\"<>:;\\/?. er tilladt",
        "menus.Selecionar": "Vælg",
        "menus.Idioma": "Sprog",
        "menus.Temperatura de pré-aquec 1": "Forvarmningstemperatur 1",
        "menus.Informe a temperatura de pré-aquec 1":
        "Angiv forvarmningstemperatur 1",
        "menus.Temperatura de pré-aquec 2": "Forvarmningstemperatur 2",
        "menus.Informe a temperatura de pré-aquec 2":
        "Angiv forvarmningstemperatur 2",
        "menus.Tempo para estabilização": "Tid til stabilisering",
        "menus.Informe o tempo para estabilização":
        "Angiv tiden til stabilisering",
        "menus.Desativar pré-aquec 2": "Deaktiver forvarmning 2",
        "menus.Configurações de data e hora": "Indstillinger for dato og klokkeslæt",
        "menus.Data:": "Dato:",
        "menus.DD/MM/AAAA": "DD/MM/ÅÅÅÅ",
        "menus.Hora:": "Tid:",
        "menus.24h": "24 t",
        "menus.AM/PM": "AM/PM",
        "menus.EUR: DD/MM/AAAA": "EUR: DD/MM/ÅÅÅÅ",
        "menus.USA: MM/DD/AAAA": "USA: MM/DD/ÅÅÅÅ",
        "menus.ISO: AAAA/MM/DD": "ISO: ÅÅÅÅ/MM/DD",
        "menus.Seleção de acessos para habilitar":
        "Valg af adgangsrettigheder, der skal aktiveres",
        "menus.Modo manual": "Manuel tilstand",
        "menus.Habilitado": "Aktiveret",
        "menus.Desabilitado": "Deaktiveret",
        "menus.Favoritos": "Favoritter",
        "menus.Aquecer/Dourar": "Opvarm/Brun mere",
        "menus.Repetir receita": "Gentag opskrift",
        "menus.Configurações gerais do menu": "Generelle menuindstillinger",
        "menus.Temperatura:": "Temperatur:",
        "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
        "menus.Gramas": "Gram",
        "menus.Oz": "Oz",
        "menus.Tema:": "Tema:",
        "menus.Dark": "Mørk",
        "menus.Light": "Lys",
        "menus.Introdução:": "Introduktion:",
        "menus.Ativada": "Aktiveret",
        "menus.Desativada": "Deaktiveret",
        "menus.Menu deletado com sucesso!": "Menu slettet!",
        "menus.Não foi possivel deletar o menu": "Det var ikke muligt at slette menuen",
        "menus.Sim": "Ja",
        "menus.Não": "Nej",
        "menus.Excluir definitivamente": "Slet permanent",
        "menus.SALVAR NO DISPOSITIVO": "GEM PÅ ENHED",
        "menus.EXPORTAR": "EKSPORTER",
        "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.":
        "Vælg de udstyrsmodeller og -versioner, der skal modtage menuen.",
        "menus.Forno": "Ovn",
        "menus.Fundo verde": "Grøn baggrund",
        "menus.Fundo preto": "Sort baggrund",
        "menus.Linux": "Linux",
        "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.":
        "Bemærk: Før menuen overføres fra USB-nøglen til udstyret, skal filen udpakkes, undtagen for menuer til Linux-udstyr.",
        "menus.Selecione os equipamentos para os quais deseja exportar o menu.":
        "Vælg de enheder, som menuen skal eksporteres til.",
        "menus.Nome do equipamento": "Udstyrets navn",
        "menus.Selecionar todos": "Vælg alle",
        "menus.Selecionar todas": "Vælg alle",
        "menus.Categoria: ": "Kategori: ",
        "menus.Você deseja excluir o menu?": "Ønsker du at slette menuen?",
        "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.":
        "Menuen slettes fra platformen, men forbliver på udstyret. En sikkerhedskopi oprettes automatisk og vil være tilgængelig i 30 dage under Mine menuer - Papirkurv.",
        "menus.Você deseja excluir o arquivo definitivamente?":
        "Ønsker du at slette filen permanent?",
        "menus.Esta ação não poderá ser desfeita.":
        "Denne handling kan ikke fortrydes.",
        "menus.Menu editado com sucesso!": "Menuen er opdateret!",
        "menus.IMPORTAR": "IMPORTER",
        "menus.VERIFICAÇÃO DE VERSÃO": "VERSIONSKONTROL",
        "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:":
        "Følg disse trin for at kontrollere printkortversionen på dit udstyr:",
        "menus.No forno, acesse Configurações;": "Åbn Indstillinger på ovnen;",
        "menus.Insira a senha 456789;": "Indtast adgangskoden 456789;",
        "menus.Selecione a opção Sistema;": "Vælg indstillingen System;",
        "menus.Selecione Informações do Fabricante;":
        "Vælg Producentoplysninger;",
        "menus.O modelo de sua placa estará na linha Firmware IHM;":
        "Printkortets model vises på linjen Firmware IHM;",
        "menus.1ª geração A": "1. generation A",
        "menus.Firmware IHM: 12.3.4": "Firmware IHM: 12.3.4",
        "menus.1ª geração B": "1. generation B",
        "menus.2ª geração/Linux:": "2. generation/Linux:",
        "menus.Firmware IHM: L1.2.3": "Firmware IHM: L1.2.3",
        "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento":
        "Vælg model/version af det udstyr, som du vil importere menuen fra. Se, hvordan du kontrollerer versionen af dit udstyr.",
        "menus.Como verificar a versão da placa":
        "Sådan kontrolleres printkortversionen",
        "menus.1° Geração": "1. generation",
        "menus.Menu restaurado com sucesso!": "Menuen blev gendannet!",
        "menus.Não foi possivel restaurar o menu":
        "Det var ikke muligt at gendanne menuen",
        "menus.RESTAURAR ARQUIVO": "GENDAN FIL",
        "menus.Você deseja restaurar o arquivo?":
        "Vil du gendanne filen?",
        "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.":
        "Filen gendannes som en ny version på platformen under fanen Alle. For at gemme den på udstyret skal du eksportere den.",
        "menus.EXCLUIR MENU": "SLET MENU",
        "menus.Nenhum equipamento associado": "Intet tilknyttet udstyr",
        "menus.Nomeie o novo menu": "Navngiv den nye menu",
        "menus.Nomeie o novo grupo": "Navngiv den nye gruppe",
        "menus.Nome do grupo": "Gruppenavn",
        "menus.Preencha o nome do grupo sem caracteres especiais": "Angiv gruppenavnet uden specialtegn",
        "menus.Pré-aquecimento:": "Forvarmning:",
        "menus.Grupo criado com sucesso!": "Gruppen blev oprettet!",
        "menus.SELECIONE UMA IMAGEM": "VÆLG ET BILLEDE",
        "menus.SELECIONAR": "VÆLG",
        "menus.Selecionar do dispositivo": "Vælg fra enheden",
        "menus.Selecionar do banco de imagens": "Vælg fra billedbiblioteket",
        "menus.Formato .JPG ou .PNG": "Format .JPG eller .PNG",
        "menus.Procurar imagem": "Søg efter billede",
        "menus.Pertence ao menu": "Tilhører menuen",
        "menus.Alterar imagem": "Skift billede",
        "menus.Remover imagem": "Fjern billede",
        "menus.EDITAR GRUPO": "REDIGER GRUPPE",
        "menus.Nome:": "Navn:",
        "menus.CRIAR RECEITA": "OPRET OPSKRIFT",
        "menus.SALVAR DO COOKBOOK": "GEM FRA COOKBOOK",
        "menus.Procurar receita do grupo": "Søg efter gruppeopskrift",
        "menus.Ingrediente principal": "Hovedingrediens",
        "menus.Limpar filtros": "Ryd filtre",
        "menus.Filtrar": "Filtrer",
        "menus.Mover receitas": "Flyt opskrifter",
        "menus.Excluir receitas": "Slet opskrifter",
        "menus.Editar grupo": "Rediger gruppe",
        "menus.Excluir grupo": "Slet gruppe",
        "menus.aqui": "her",
        "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.":
        "Hvis koden kun består af tal, og skærmbaggrunden er grøn, tilhører den 1. generation A. Hvis den kun består af tal, og baggrunden er sort, tilhører den 1. generation B. Hvis den begynder med bogstaverne L, F eller S, tilhører printkortet 2. generation/Linux.",
        "menus.1ª A - Fundo verde": "1. A - Grøn baggrund",
        "menus.1ª B - Fundo preto": "1. B - Sort baggrund",
        "menus.2ª - Linux": "2. - Linux",
        "menus.Tivemos um problema. Tente novamente mais tarde.":
        "Der opstod et problem. Prøv venligst igen senere.",
        "menus.Grupo editado com sucesso!": "Gruppen blev redigeret!",
        "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "DER ER ENDNU INGEN GRUPPER HER :(",
        "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Klik på knappen i øverste højre hjørne for at tilføje grupper.",
        "menus.NENHUM MENU NA LIXEIRA": "INGEN MENUER I PAPIRKURVEN",
        "menus.AINDA NÃO HÁ MENUS AQUI :(": "DER ER ENDNU INGEN MENUER HER :(",
        "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Klik på en af knapperne i øverste højre hjørne for at tilføje menuer.",
        "menus.Adicionar imagem": "Tilføj billede",
        "menus.Nome da receita": "Opskriftens navn",
        "menus.Detalhes da receita": "Opskriftsdetaljer",
        "menus.Programação da receita": "Opskriftsprogrammering",
        "menus.Nomeie sua receita": "Navngiv din opskrift",
        "menus.Preencha o nome da receita sem caracteres especiais": "Angiv opskriftens navn uden specialtegn",
        "menus.Tipo de prato": "Rettype",
        "menus.SALVAR RECEITAS DO COOKBOOK": "GEM OPSKRIFTER FRA COOKBOOK",
        "menus.Selecione as receitas que deseja salvar no grupo de seu menu:":
        "Vælg de opskrifter, du vil gemme i gruppen i din menu:",
        "menus.Procurar receita": "Søg efter opskrift",
        "menus.deleteGroupSuccess":
        "{count, plural, one {Gruppen blev slettet!} other {Grupperne blev slettet!}}",
        "menus.deleteGroupError":
        "{count, plural, one {Det var ikke muligt at slette gruppen.} other {Det var ikke muligt at slette grupperne.}}",
        "menus.EXCLUIR GRUPO": "SLET GRUPPE",
        "menus.confirmDeleteGroupMessage":
        "{count, plural, one {Vil du slette gruppen permanent?} other {Vil du slette grupperne permanent?}}",
        "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "DER ER ENDNU INGEN OPSKRIFTER HER :(",
        "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Klik på en af knapperne i øverste højre hjørne for at tilføje opskrifter.",
        "menus.Temp. de entrada": "Indgangstemp.",
        "menus.Temp. de pré-aquec": "Forvarmningstemp.",
        "menus.Ingredientes para montagem": "Ingredienser til samling",
        "menus.Instruções operacionais": "Betjeningsvejledning",
        "menus.Passo": "Trin",
        "menus.Temp": "Temp.",
        "menus.Temp.": "Temp.",
        "menus.Tempo": "Tid",
        "menus.Velocidade do ar": "Lufthastighed",
        "menus.Micro-ondas": "Mikrobølger",
        "menus.Resistência inferior": "Nederste varmelegeme",
        "menus.Informações": "Information",
        "menus.Digite as informações do passo": "Indtast oplysningerne for trinnet",
        "menus.desativar": "deaktivér",
        "menus.Ingredientes": "Ingredienser",
        "menus.Temperatura de entrada": "Indgangstemperatur",
        "menus.Equipamentos compatíveis": "Kompatibelt udstyr",
        "menus.Tempo total": "Samlet tid",
        "menus.SALVAR NO COOKBOOK": "GEM I COOKBOOK",
        "menus.ver localização": "vis placering",
        "menus.SELECIONE RECEITAS PARA EXCLUIR": "VÆLG OPSKRIFTER TIL SLETNING",
        "menus.Você deseja excluir as receitas selecionadas definitivamente?":
        "Vil du slette de valgte opskrifter permanent?",
        "menus.Receitas deletadas com sucesso!": "Opskrifterne blev slettet!",
        "menus.Informe aqui os ingredientes para montagem":
        "Indtast ingredienserne til samling her",
        "menus.Informe aqui as instruções operacionais":
        "Indtast betjeningsvejledningen her",
        "menus.Adicionar passo": "Tilføj trin",
        "menus.Receita criada com sucesso!": "Opskriften blev oprettet!",
        "menus.Ideal para:": "Ideel til:",
        "menus.editar detalhes": "rediger detaljer",
        "menus.excluir": "slet",
        "menus.editar": "rediger",
        "menus.Receita editada com sucesso!": "Opskriften blev redigeret!",
        "menus.Passo deletado com sucesso!": "Trinnet blev slettet!",
        "menus.Não foi possivel deletar o passo":
        "Det var ikke muligt at slette trinnet",
        "menus.EXCLUIR PASSO": "SLET TRIN",
        "menus.Você deseja excluir este passo?": "Vil du slette dette trin?",
        "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.":
        "Denne handling kan ikke fortrydes. Hvis du foretrækker det, kan du blot deaktivere trinnet og dermed bevare dets konfiguration.",
        "menus.Peso": "Vægt",
        "menus.Origem da receita": "Opskriftens oprindelse",
        "menus.Pré-aquecimento": "Forvarmning",
        "menus.Plataforma": "Platform",
        "menus.Receita salva com sucesso!": "Opskriften blev gemt!",
        "menus.Exportar receitas": "Eksportér opskrifter",
        "menus.expandir": "udvid",
        "menus.Temperatura": "Temperatur",
        "menus.Vapor combinado": "Kombidamp",
        "menus.Ar quente": "Varm luft",
        "menus.Sonda": "Stegesonde",
        "menus.Tempo (min)": "Tid (min)",
        "menus.Umidade (%)": "Fugtighed (%)",
        "menus.Injeção de vapor": "Dampindsprøjtning",
        "menus.Dumper aberto": "Dumper åben",
        "menus.Informe o peso": "Angiv vægten",
        "menus.Informe a temperatura de entrada":
        "Angiv indgangstemperaturen",
        "menus.Informe os ingredientes para montagem":
        "Angiv ingredienserne til samling",
        "menus.Informe as instruções operacionais":
        "Angiv betjeningsvejledningen",
        "menus.Injeção de vapor (seg)": "Dampindsprøjtning (sek.)",
        "menus.Aquecer mais": "Opvarm mere",
        "menus.Dourar mais": "Brun mere",
        "menus.Aquecer e dourar mais": "Opvarm og brun mere",
        "menus.Favoritar receita": "Tilføj opskrift til favoritter",
        "menus.Informe o tempo para aquecer mais":
        "Angiv tiden for opvarmning",
        "menus.Informe o tempo para dourar mais":
        "Angiv tiden for bruning",
        "menus.Informe o tempo para aquecer e dourar mais":
        "Angiv tiden for opvarmning og bruning",
        "menus.Apenas favoritos": "Kun favoritter",
        "menus.Forno combinado": "Kombiovn",
        "menus.Cocção múltipla": "Multitilberedning",
        "menus.Receitas Technicook": "Technicook-opskrifter",
        "menus.Editar grupos": "Rediger grupper",
        "menus.Informe a data": "Angiv datoen",
        "menus.Informe a hora": "Angiv klokkeslættet",
        "menus.até 300": "op til 300",
        "menus.Vapor": "Damp",
        "menus.Turbina": "Blæser",
        "menus.Criar grupo": "Opret gruppe",
        "menus.MOVER": "FLYT",
        "menus.Configurações de data e hora:": "Indstillinger for dato og klokkeslæt:",
        "menus.Configurações de acessos:": "Adgangsindstillinger:",
        "menus.Modo manual:": "Manuel tilstand:",
        "menus.Favoritos:": "Favoritter:",
        "menus.Aquecer/dourar:": "Opvarm/brun:",
        "menus.Repetir receita:": "Gentag opskrift:",
        "menus.Configurações gerais do menu:": "Generelle menuindstillinger:",
        "menus.SELECIONE RECEITAS PARA MOVER": "VÆLG OPSKRIFTER TIL FLYTNING",
        "menus.AVANÇAR": "NÆSTE",
        "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Vælg eller opret en gruppe i den samme menu for at flytte de valgte opskrifter, eller flyt dem til en anden menu. Bemærk, at kun menuer/grupper, der er kompatible med opskrifternes forudindstillinger, vises.",
        "menus.Mover receitas para o mesmo menu": "Flyt opskrifter til den samme menu",
        "menus.Mover receitas para outro menu": "Flyt opskrifter til en anden menu",
        "menus.Selecionar grupo": "Vælg gruppe",
        "menus.Nenhuma receita foi selecionada": "Ingen opskrift blev valgt",
        "menus.Passo editado com sucesso!": "Trinnet blev redigeret!",
        "menus.Menu atualizado": "Menu opdateret",
        "menus.até 260": "op til 260",
        "menus.Umidade na câmara": "Fugtighed i kammeret",
        "menus.Passos": "Trin",
        "menus.ativar": "aktivér",
        "menus.Informe a temperatura de pré-aquec": "Angiv forvarmningstemperaturen",
        "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.":
        "Flyt de valgte opskrifter til en anden menu. Bemærk, at kun menuer, der er kompatible med opskrifternes forudindstillinger, vil blive vist.",
        "menus.Sonda (°C)": "Stegesonde (°C)",
        "menus.Turbo Grill": "Turbo Grill",
        "menus.Pré-aquecimento padrão, conforme passo 1": "Standardforvarmning i henhold til trin 1",
        "menus.salvar": "gem",
        "menus.até": "op til",
        "menus.Verificação de receita": "Opskriftskontrol",
        "menus.Auto import": "Automatisk import",
        "menus.Atualização forçada": "Tvungen opdatering",
        "menus.Lista de receitas exportada com sucesso!": "Opskriftslisten blev eksporteret!",
        "menus.Receita movida com sucesso!": "Opskriften blev flyttet!",
        "menus.Receitas movidas com sucesso!": "Opskrifterne blev flyttet!",
        "menus.+ Menu": "+ Menu",
        "menus.+ Receita": "+ Opskrift",
        "menus.Selecione o modelo/versão do equipamento": "Vælg udstyrets model/version",
        "menus.Escolha um idioma compatível com o equipamento": "Vælg et sprog, der er kompatibelt med udstyret",
        "menus.MENU IMPORTADO COM SUCESSO!": "MENU IMPORTERET!",
        "menus.Dourar": "Brun",
        "menus.Não atribuir a menu": "Tildel ikke til menu",
        "menus.Todos": "Alle",
        "menus.Meus menus": "Mine menuer",
        "menus.Para salvar uma receita, preencha todos os campos": "For at gemme en opskrift skal du udfylde alle felter",
        "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Vælg de udstyrsgrupper, som menuen skal eksporteres til.",
        "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Ugyldigt format. Kun .jpeg- og .png-formater er tilladt",
        "menus.Reordenar grupos": "Omarranger grupper",
        "menus.O que deseja fazer?": "Hvad vil du gerne gøre?",
        "menus.Reordenar receitas": "Omarranger opskrifter",
        "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "ELEMENTERNE BLEV OMARRANGERET! FOR AT ANVENDE ÆNDRINGERNE PÅ OVNEN SKAL DU EKSPORTERE MENUEN.",
        "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "TRÆK ELEMENTERNE TIL DEN ØNSKEDE PLACERING",
        "menus.Dumper": "Dumper",
        "menus.Aberto": "Åben",
        "menus.Fechado": "Lukket",
        "menus.Intermitente": "Intermitterende",
        "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Hvis din menu indeholder produkter, der er følsomme over for ensartethed, anbefaler vi at indstille stabiliseringstiden til mellem 3:00 og 5:00 minutter. Ellers kan du lade den være på 5 sekunder.",
        "menus.Selecione o menu que deseja exportar:": "Vælg den menu, du vil eksportere:",
        "menus.Temperatura de pré-aquecimento": "Forvarmningstemperatur",
        "menus.Temperatura de lastro": "Bundtemperatur",
        "menus.Temperatura de teto": "Lofttemperatur",
        "menus.Volume de injeção de vapor (ml)": "Dampindsprøjtningsvolumen (ml)",
        "menus.Parada de turbina": "Blæserstop",
        "menus.Alta": "Høj",
        "menus.Média": "Mellem",
        "menus.Baixa": "Lav",
        "menus.a": "til",
        "menus.Valor da injeção": "Indsprøjtningsværdi",
        "menus.Volume: até 999ml": "Volumen: op til 999 ml",
        "menus.Tempo: até 15 segundos": "Tid: op til 15 sekunder",
        "menus.Tempo de injeção de vapor (seg)": "Tid for dampindsprøjtning (sek.)",
        "menus.Atenção!": "Bemærk!",
        "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Kontrollér menuens opskrifter, og justér værdierne for dampindsprøjtning efter ændring af måleenheden.",
        "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Sørg for, at temperaturenheden (°C eller °F), der er indstillet på udstyret, er den samme som den, der blev valgt ved oprettelsen af menuen:",
        "menus.Injeção desativada": "Dampindsprøjtning deaktiveret",
        "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Vælg den temperaturenhed, der er indstillet på udstyret:",
        "menus.Clique para atualizar": "Klik for at opdatere",
        "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "Funktionen Tvungen opdatering sender automatisk menuen til de valgte enheder, som har en version, der er kompatibel med denne type opdatering, næste gang de tændes. Ovne, der endnu ikke er opdateret, skal stadig acceptere opdateringen manuelt.",
        "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "De valgte indstillinger vil være tilgængelige på de enheder, der modtager denne menu, og kan bruges af operatøren. Disse indstillinger kan senere ændres direkte på ovnen eller via platformen.",
        "menus.Não foi possivel deletar as receitas": "Det var ikke muligt at slette opskrifterne",
        "menus.PRÉ": "FOR",
        "menus.Speed Ovens": "Speed Ovens",
        "menus.Fornos Combinados": "Kombiovne",
        "menus.Fornos de Panificação": "Bageriovne",
        "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "Når menuen er oprettet, kan menutypen ikke ændres. Den kan kun vælges under oprettelsen.",
        "menus.Pré-aquecimento do grupo": "Gruppeforvarmning",
        "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Bemærk: Før menuen overføres fra USB-drevet til udstyret, skal filen udpakkes, og mappen PRATICA skal overføres til udstyret.",
        "menus.Tamanho máximo": "Maksimal størrelse",
        "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Giver ovnoperatøren mulighed for at oprette parametre og derefter køre dem.",
        "menus.Acesso também à execução das receitas favoritas.": "Giver også adgang til at køre favoritopskrifter.",
        "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Giver operatøren mulighed for at tilføje ekstra tid til opvarmning/bruning af retten efter tilberedningen.",
        "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Giver mulighed for at gentage opskriften, så snart tilberedningen er afsluttet.",
        "menus.Acesso exclusivo às receitas favoritas.": "Eksklusiv adgang til favoritopskrifter.",
        "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Aktiverer en påmindelse til operatøren om at kontrollere, om maden allerede er sat ind i ovnen.",
        "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "Ovnen importerer automatisk en menu, der er gemt på et isat USB-drev, når den tændes.",
        "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Gør det muligt at tilberede flere forskellige fødevarer samtidig, én i hver GN.",
        "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Giver mulighed for at køre fabriksforudprogrammerede opskrifter.",
        "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Giver adgang til Turbo Grill-funktionen, som når op til 300 °C.",
        "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Giver operatøren mulighed for at tilføje ekstra tid til bruning af retten efter tilberedningen.",
        "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Giver operatøren mulighed for at redigere opskriftsgrupper direkte fra startskærmen.",
        "menus.Copiar grupos": "Kopiér grupper",
        "menus.Excluir grupos": "Slet grupper",
        "menus.Copiar": "Kopiér",
        "menus.Selecione grupos para copiar": "Vælg grupper, der skal kopieres",
        "menus.Selecione o destino dos grupos": "Vælg destination for grupperne",
        "menus.Colar": "Indsæt",
        "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Vil du annullere kopieringen og afsendelsen af grupper til menuerne?",
        "menus.Grupos colados com sucesso": "{count, plural, one {Gruppen blev indsat!} other {Grupperne blev indsat!}}",
        "menus.Copiar receitas": "Kopiér opskrifter",
        "menus.Selecione receitas para copiar": "Vælg opskrifter, der skal kopieres",
        "menus.Selecione o destino das receitas": "Vælg destinationen for opskrifterne",
        "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Vil du annullere kopieringen og afsendelsen af opskrifter til grupperne?",
        "menus.Receitas coladas com sucesso": "{count, plural, one {Opskriften blev indsat!} other {Opskrifterne blev indsat!}}",
        "menus.Converter para C-MAX EVO": "Konvertér til C-MAX EVO",
        "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "Der oprettes en kopi af denne menu, tilpasset til C-MAX EVO. Vi anbefaler, at du gennemgår alle trinparametre omhyggeligt og opdaterer opskrifterne med nye billeder, hvis det er nødvendigt.",
        "menus.Menu convertido com sucesso!": "Menuen blev konverteret!",
        "menus.Não foi possível converter o menu. Tente novamente mais tarde": "Det var ikke muligt at konvertere menuen. Prøv venligst igen senere",
        "menus.O menu está sendo convertido... Aguarde!": "Menuen bliver konverteret... Vent venligst!",
        "menus.Menu incompatível com": "Menu inkompatibel med",
        "menus.Selecione pelo menos um grupo": "Vælg mindst én gruppe",
        "menus.Selecione pelo menos um menu": "Vælg mindst én menu",
        "menus.Menu atual": "Aktuel menu",
        "menus.Copiando grupos": "{count, plural, one {Gruppen kopieres... Vent venligst!} other {Grupperne kopieres... Vent venligst!}}",
        "menus.Erro ao copiar grupos": "{count, plural, one {Det var ikke muligt at kopiere gruppen. Prøv venligst igen senere!} other {Det var ikke muligt at kopiere grupperne. Prøv venligst igen senere!}}",
        "menus.Procurar pelo nome do menu": "Søg efter menunavn",
        "menus.Escolha um grupo de destino para cada menu selecionado": "Vælg en destinationsgruppe for hver valgt menu!",
        "menus.Copiando receitas": "{count, plural, one {Opskriften kopieres... Vent venligst!} other {Opskrifterne kopieres... Vent venligst!}}",
        "menus.Erro ao copiar receitas": "{count, plural, one {Det var ikke muligt at kopiere opskriften. Prøv venligst igen senere!} other {Det var ikke muligt at kopiere opskrifterne. Prøv venligst igen senere!}}",
        "menus.SELECIONE GRUPOS PARA EXCLUIR": "VÆLG GRUPPER TIL SLETNING",
        "menus.Padeiro noturno": "Natbager",
        "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Gør det muligt at planlægge starten (forvarmning) af en specifik opskrift eller en manuelt indtastet opskrift (Manuel tilstand), uden at en operatør behøver at være til stede.",
        "menus.Vaporizador": "Dampgenerator",
        "menus.Editar receitas": "Rediger opskrifter",
        "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Giver operatøren mulighed for at redigere opskrifter direkte fra startskærmen.",
        "menus.Preencha o nome da receita": "Angiv opskriftens navn",
        "menus.Tempo nível": "Tidsniveau",
        "menus.Fermentadora": "Hæveskab",
        "menus.0 ou 5 a 59s": "0 eller 5 til 59 s",
        "menus.Selecione uma imagem" : "Vælg et billede",
        "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*For at oprette opskrifter til ovne uden internetforbindelse skal du først oprette en menu og derefter opskrifterne.",
        "menus.CONVERTER": "KONVERTER",
        "menus.Converter para FIT": "Konverter til FIT",
        "menus.Converter para outro FIT": "Konverter til en anden FIT",
        "menus.Selecione pelo menos um modelo FIT": "Vælg mindst én FIT-model",
        "menus.O menu está sendo convertido para FIT... Aguarde!": "Menuen konverteres til FIT... Vent venligst!",
        "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} menu(er) blev konverteret til FIT!",
        "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Nogle menuer blev konverteret, men konverteringen mislykkedes for: {models}",
        "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "Der oprettes en kopi af denne menu for hver valgt FIT-model med bevarelse af indstillinger, grupper, opskrifter og trin.",
        "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu." : "Der oprettes en kopi af denne menu for hver valgt FIT-model med bevarelse af indstillinger, grupper, opskrifter og trin. Da hver ovn har sine egne mål og egenskaber, anbefaler vi dog, at du gennemgår og justerer parametrene for at sikre den bedste ydeevne og de bedste resultater på hvert udstyr. Vælg den FIT-model, som menuen skal konverteres til.",
        
        //COOKBOOK
        "cookbook.RECEITAS DISPONÍVEIS": "TILGÆNGELIGE OPSKRIFTER",
        "cookbook.RECEITAS SALVAS": "GEMTE OPSKRIFTER",
        "cookbook.ENVIAR PARA MENU": "SEND TIL MENU",
        "cookbook.SALVAR": "GEM",
        "cookbook.salvar": "gem",
        "cookbook.Filtrar por": "Filtrer efter",
        "cookbook.Procurar receita do cookbook": "Søg efter opskrift i Cookbook",
        "cookbook.Equipamento": "Udstyr",
        "cookbook.Ingrediente principal": "Hovedingrediens",
        "cookbook.Tipo de prato": "Rettype",
        "cookbook.Região": "Region",
        "cookbook.Pré-aquecimento": "Forvarmning",
        "cookbook.Procurar receita": "Søg efter opskrift",
        "cookbook.Menu": "Menu",
        "cookbook.ENVIAR": "SEND",
        "cookbook.Procurar nome do menu": "Søg efter menunavn",
        "cookbook.Escolha um grupo deste menu": "Vælg en gruppe i denne menu",
        "cookbook.Selecionar grupo": "Vælg gruppe",
        "cookbook.Tivemos um problema. Tente novamente mais tarde":
        "Der opstod et problem. Prøv igen senere",
        "cookbook.Receita adicionada com sucesso!": "Opskriften blev tilføjet!",
        "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde":
        "Det var ikke muligt at tilføje opskriften. Prøv igen senere",
        "cookbook.Selecione um menu e um grupo para enviar esta receita":
        "Vælg en menu og en gruppe for at sende denne opskrift",
        "cookbook.A receita não foi adicionada ao menu pois não há grupos criados":
        "Opskriften blev ikke tilføjet til menuen, da der ikke er oprettet nogen grupper",
        "cookbook.Selecione o modelo do equipamento primeiro": "Vælg først udstyrsmodellen",
        "cookbook.Grupo": "Gruppe",
        "cookbook.Não foi possível salvar os passos da receita": "Det var ikke muligt at gemme opskriftens trin",
        "cookbook.Bovina": "Oksekød",
        "cookbook.Frango": "Kylling",
        "cookbook.Ovos": "Æg",
        "cookbook.Pães": "Brød",
        "cookbook.Peixes": "Fisk",
        "cookbook.Queijo": "Ost",
        "cookbook.Suína": "Svinekød",
        "cookbook.Vegetais": "Grøntsager",
        "cookbook.Outros": "Andre",
        "cookbook.Entradas/aperitivos": "Forretter/snacks",
        "cookbook.Principais": "Hovedretter",
        "cookbook.Snacks": "Snacks",
        "cookbook.Pizzas": "Pizzaer",
        "cookbook.Massas": "Pasta",
        "cookbook.Acompanhamentos": "Tilbehør",
        "cookbook.Sobremesas": "Desserter",
        "cookbook.Manhã": "Morgenmad",
        "cookbook.Padaria": "Bageri",
        "cookbook.Todos": "Alle",
        "cookbook.Não atribuir origem": "Tildel ikke oprindelse",
        "cookbook.Brasil": "Brasilien",
        "cookbook.Alemanha": "Tyskland",
        "cookbook.França": "Frankrig",
        "cookbook.Rússia": "Rusland",
        "cookbook.China": "Kina",
        "cookbook.Japão": "Japan",
        "cookbook.Itália": "Italien",
        "cookbook.Egito": "Egypten",
        "cookbook.Grécia": "Grækenland",
        "cookbook.Argentina": "Argentina",
        "cookbook.África": "Afrika",
        "cookbook.Estados Unidos": "USA",
        "cookbook.Coreia": "Korea",
        "cookbook.Turquia": "Tyrkiet",
        "cookbook.Ideal para": "Ideel til",
        "cookbook.Polônia": "Polen",
        "cookbook.Sanduíches": "Sandwiches",
        "cookbook.Nova Receita": "Ny opskrift",
        
        //EQUIPAMENTOS
        "equipment.equipamentos": "udstyr",
        "equipment.procurar equipamento": "Søg efter udstyr eller bruger",
        "equipment.adicionar equipamento": "tilføj udstyr",
        "equipment.atualizar equipamento": "opdater udstyr",
        "equipment.+ equipamentos": "+ udstyr",
        "equipment.buscar equipamento": "Søg efter udstyr",
        "equipment.Desvincular": "Fjern tilknytning",
        "equipment.Editar": "Rediger",
        "equipment.sem conteúdo": "DER ER ENDNU INTET UDSTYR HER :(",
        "equipment.description.sem conteúdo": "Klik på knappen Tilføj udstyr øverst til højre for at tilknytte dine ovne.",
        "equipment.editar equipamento": "rediger udstyr",
        "equipment.equipamento editado com sucesso!": "Udstyret blev redigeret!",
        "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "Det var ikke muligt at redigere udstyret. Prøv igen senere",
        "equipment.Menu exportado com sucesso!": "Menuen blev eksporteret!",
        "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "Det var ikke muligt at eksportere menuen. Prøv igen senere",
        "equipment.Selecione pelo menos um equipamento para enviar o menu": "Vælg mindst ét udstyr for at sende menuen",
        "equipment.Informações do menu": "Menuoplysninger",
        "equipment.Procurar receita ou grupo": "Søg efter opskrift eller gruppe",
        "equipment.Grupo": "Gruppe",
        "equipment.Grupos de equipamentos": "Udstyrsgrupper",
        "equipment.Receita": "Opskrift",
        "equipment.Quantidade": "Antal",
        "equipment.Receitas mais preparadas no equipamento durante o período": "Mest tilberedte opskrifter på udstyret i perioden",
        "equipment.Informações de limpeza": "Rengøringsoplysninger",
        "equipment.Data da limpeza": "Rengøringsdato",
        "equipment.Hora da limpeza": "Tidspunkt for rengøring",
        "equipment.nome": "Navn",
        "equipment.modelo": "Model",
        "equipment.categoria": "Kategori",
        "equipment.loja": "Butik",
        "desvincular equipamento": "Fjern tilknytning af udstyr",
        "equipment.unlink.paragrafo 1":
        "Ønsker du at fjerne udstyrets tilknytning til IOK-platformen?",
        "equipment.unlink.paragrafo 2":
        "Når du gør dette, vil det ikke længere være muligt at administrere dets indstillinger og menu via platformen, medmindre du tilknytter udstyret igen ved at følge forbindelsesvejledningen.",
        "equipamento desvinculado com sucesso!":
        "Udstyret blev fjernet fra tilknytningen!",
        "equipment.ocorreu um erro. Tente novamente mais tarde":
        "Der opstod en fejl. Prøv igen senere",
        "equipment.sim": "Ja",
        "equipment.não": "Nej",
        "equipment.Encerrar acesso remoto": "Afslut fjernadgang",
        "equipment.Horas sem limpeza": "Timer uden rengøring",
        "equipment.Histórico de eventos": "Hændelseshistorik",
        "equipment.Histórico de eventos do forno": "Ovnens hændelseshistorik",
        "equipment.Histórico de eventos da fermentadora": "Hændelseshistorik for hæveskab",
        "equipment.Receitas executadas": "Tilberedte opskrifter",
        "equipment.Hoje": "I dag",
        "equipment.Tempo de porta aberta": "Tid med åben dør",
        "equipment.Tempo médio aproximado": "Omtrentlig gennemsnitstid",
        "equipment.Filtrar eventos": "Filtrer hændelser",
        "equipment.Evento": "Hændelse",
        "equipment.Data": "Dato",
        "equipment.ERRO SENSOR RI": "Fejl i sensor for nederste varmeelement",
        "equipment.ERRO COM INV. DE FREQ.": "Fejl i frekvensomformer",
        "equipment.ERRO MAGNETRON": "Magnetronfejl",
        "equipment.ERRO SENSOR CAMARA": "Fejl i kammersensor",
        "equipment.ERRO CAN": "CAN-fejl",
        "equipment.Erro INVERSOR DE FREQUENCIA": "Fejl i frekvensomformer",
        "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Fejl i udstyrsmodel",
        "equipment.ERRO PAINEL": "Panelfejl",
        "equipment.ERRO INV.FREQ.STATUS": "Fejl i frekvensomformerstatus",
        "equipment.ERRO SENSOR BOARD": "Fejl i printkortsensor",
        "equipment.ERRO ENERGY": "Energifejl",
        "equipment.ERRO I2C": "I2C-fejl",
        "equipment.EQUIPAMENTO LIGADO": "Udstyr tændt",
        "equipment.EQUIPAMENTO DESLIGADO": "Udstyr slukket",
        "equipment.Plataforma": "Platform",
        "equipment.Forno": "Ovn",
        "equipment.Origem": "Oprindelse",
        "equipment.Locais": "Lokationer",
        "equipment.não foi possível carregar as entidades": "Det var ikke muligt at indlæse enhederne",
        "equipment.conceder acesso remoto a": "Giv fjernadgang til",
        "equipment.atualizar software": "opdater software",
        "equipment.suporte": "support",
        "equipment.PIN": "PIN",
        "equipment.nome do equipamento": "Udstyrsnavn",
        "equipment.vinculado à loja": "Tilknyttet butik",
        "equipment.cadastrar loja": "Registrer butik",
        "equipment.informe o PIN do forno": "Angiv ovnens PIN",
        "equipment.preencha o PIN do forno": "Udfyld ovnens PIN",
        "equipment.adicione um nome para facilitar seu reconhecimento":
        "Tilføj et navn for at gøre udstyret lettere at genkende",
        "equipment.preencha o nome do equipamento": "Udfyld udstyrets navn",
        "equipment.selecionar": "Vælg",
        "equipment.nome fantasia": "Butiksnavn",
        "equipment.informe o nome fantasia": "Angiv butiksnavnet",
        "equipment.preencha o nome fantasia": "Udfyld butiksnavnet",
        "equipment.CNPJ": "CVR/CNPJ",
        "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
        "equipment.preencha o CNPJ": "Udfyld CNPJ",
        "equipment.CEP": "Postnummer",
        "equipment.00000-000": "00000-000",
        "equipment.preencha o CEP": "Udfyld postnummeret",
        "equipment.cidade": "By",
        "equipment.informe a cidade": "Angiv byen",
        "equipment.preencha a cidade": "Udfyld byen",
        "equipment.UF": "Stat",
        "equipment.bairro": "Bydel",
        "equipment.informe o bairro": "Angiv bydelen",
        "equipment.endereço": "Adresse",
        "equipment.informe o seu endereço": "Angiv din adresse",
        "equipment.preencha o seu endereço": "Udfyld din adresse",
        "equipment.Nº": "Nr.",
        "equipment.equipamento cadastrado com sucesso!":
        "Udstyret blev registreret!",
        "equipment.ocorreu um erro": "Der opstod en fejl",
        "equipment.preencha o modelo": "Udfyld modellen",
        "equipment.selecione uma categoria": "Vælg en kategori",
        "equipment.selecione uma loja": "Vælg en butik",
        "equipment.preencha o bairro": "Udfyld bydelen",
        "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde":
        "Det var ikke muligt at registrere udstyret. Prøv igen senere",
        "equipment.loja cadastrada com sucesso": "Butikken blev registreret!",
        "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde":
        "Det var ikke muligt at registrere butikken. Prøv igen senere",
        "equipment.equipment": "udstyr",
        "equipment.search equipment": "søg efter udstyr",
        "equipment.add equipment": "tilføj udstyr",
        "equipment.update equipment": "opdater udstyr",
        "equipment.plus equipment": "+ udstyr",
        "equipment.Procurar equipamento": "Søg efter udstyr",
        "equipment.EQUIPAMENTOS": "UDSTYR",
        "equipment.Atualizar equipamento": "Opdater udstyr",
        "equipment.Atualizar equipamentos": "Opdater udstyr",
        "equipment.confirmar": "bekræft",
        "equipment.Selecione os modelos que deseja atualizar:": "Vælg de modeller, du ønsker at opdatere:",
        "equipment.Como deseja realizar a atualização?": "Hvordan ønsker du at udføre opdateringen?",
        "equipment.Enviar atualização pela plataforma (internet)": "Send opdatering via platformen (internet)",
        "equipment.Salvar arquivo de atualização no dispositivo": "Gem opdateringsfil på enheden",
        "equipment.Linha Express": "Express-serien",
        "equipment.Escolha como deseja realizar a atualização": "Vælg, hvordan du ønsker at udføre opdateringen",
        "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Vælg mindst én udstyrsmodel, der skal opdateres",
        "equipment.Status: ": "Status: ",
        "equipment.Número de série:": "Serienummer:",
        "equipment.Menu:": "Menu:",
        "equipment.Status:": "Status:",
        "equipment.Número de série": "Serienummer",
        "equipment.Menu": "Menu",
        "equipment.Loja: ": "Butik: ",
        "equipment.End:": "Adr.: ",
        "equipment.Endereço:": "Adresse: ",
        "equipment.Cidade:": "By: ",
        "equipment.CEP:": "Postnummer: ",
        "equipment.Atualização de software enviada com sucesso!": "Softwareopdateringen blev sendt!",
        "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "Det var ikke muligt at sende softwareopdateringen. Prøv igen senere",
        "equipment.Download realizado com sucesso": "Download gennemført!",
        "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "Det var ikke muligt at gennemføre download. Prøv igen senere",
        "equipment.Solicitação processada com erro. Tente novamente mais tarde": "Anmodningen blev behandlet med en fejl. Prøv igen senere",
        "equipment.Preencha o nome da versão": "Udfyld versionsnavnet",
        "equipment.Informe aqui todas as alterações desta nova versão": "Angiv alle ændringer i denne nye version her",
        "equipment.Nova versão de software atualizada com sucesso!": "Den nye softwareversion blev opdateret!",
        "equipment.Informe pelo menos uma mudança nesta versão": "Angiv mindst én ændring i denne version",
        "equipment.Falha ao transformar o arquivo em Blob": "Kunne ikke konvertere filen til Blob",
        "equipment.Erro ao criar Blob a partir do arquivo": "Fejl ved oprettelse af Blob fra filen",
        "equipment.Falha ao ler o arquivo": "Kunne ikke læse filen",
        "equipment.selecionar tipo": "vælg type",
        "equipment.selecione o tipo da versão": "vælg versionstype",
        "equipment.atualização": "OPDATERING",
        "equipment.Selecione abaixo o que deseja fazer:": "Vælg nedenfor, hvad du vil gøre:",
        "equipment.Atualizar meus equipamentos": "Opdater mit udstyr",
        "equipment.Enviar atualização para usuários selecionados": "Send opdatering til udvalgte brugere",
        "equipment.ENVIAR": "SEND",
        "equipment.ENVIAR ATUALIZAÇÃO": "SEND OPDATERING",
        "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Vælg de e-mailadresser, som opdateringen skal sendes til:",
        "equipment.A atualização disponibilizada no dia": "Opdateringen, der blev gjort tilgængelig den",
        "equipment.referente ao equipamento": "vedrørende udstyret",
        "equipment.contempla o seguinte:": "omfatter følgende:",
        "equipment.Selecionar arquivo para envio": "Vælg fil til upload",
        "equipment.Por favor, selecione um arquivo .tar": "Vælg venligst en .tar-fil",
        "equipment.Selecione o modelo do equipamento:": "Vælg udstyrsmodel:",
        "equipment.Selecione uma opção": "Vælg en mulighed",
        "equipment.Nomeie a versão": "Navngiv versionen",
        "equipment.Clique sobre o arquivo que deseja baixar:": "Klik på den fil, du ønsker at downloade:",
        "equipment.Baixar atualização": "Download opdatering",
        "equipment.Versões": "Versioner",
        "equipment.e superiores": "og nyere",
        "equipment.name": "navn",
        "equipment.model": "model",
        "equipment.category": "kategori",
        "equipment.store": "butik",
        "FIT Express/FIT ST": "FIT Express/FIT ST",
        "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
        "Forza STi": "Forza STi",
        "TSi": "TSi",
        "FIT Express": "FIT Express",
        "FIT ST": "FIT ST",
        "FIT Express, FIT ST": "FIT Express, FIT ST",
        "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
        "equipment.e": "og",
        "equipment.Últimas versões de software:": "Seneste softwareversioner:",
        "equipment.Você não possui nenhum equipamento desatualizado": "Du har ingen udstyr med forældet software",
        "equipment.grupos": "grupper",
        "equipment.não foi possível carregar os grupos de equipamentos da companhia": "Det var ikke muligt at indlæse virksomhedens udstyrsgrupper",
        "equipment.vinculado ao grupo": "Tilknyttet gruppen",
        "equipment.selecione um grupo": "Vælg en gruppe",
        "equipment.cadastrar grupo": "Opret gruppe",
        "equipment.Número de Série": "Serienr.",
        "equipment.Versão": "Version",
        "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "Det var ikke muligt at registrere udstyret. Vælg eller opret en gruppe",
        "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "OPRET UDSTYRSGRUPPER!",
        "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "For at brugere, der er tilknyttet kontoen, kan se udstyret, skal du:",
        "equipment.1) Criar grupo(s);": "1) Oprette gruppe(r);",
        "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Tilknytte udstyr til gruppen;",
        "equipment.3) Atribuir usuário(s) ao grupo.": "3) Tilknytte bruger(e) til gruppen.",
        "equipment.Status software": "Softwarestatus",
        "equipment.Status menu": "Menustatus",
        "equipment.Pendente": "Afventer",
        "equipment.Aceito": "Accepteret",
        "equipment.Recusado": "Afvist",
        "equipment.Atualizar software": "Opdater software",
        "equipment.Deseja enviar a atualização para o equipamento selecionado?": "Ønsker du at sende opdateringen til det valgte udstyr?",
        "equipment.Companhia": "Virksomhed",
        "equipment.Exportar menu": "Eksporter menu",
        "equipment.companhias": "virksomheder",
        "equipment.Nome da companhia": "Virksomhedsnavn",
        "equipment.Procurar equipamento, usuário ou companhia": "Søg efter udstyr, bruger eller virksomhed",
        "equipment.Versão da power": "Power-version",
        "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "DER ER ENDNU INGEN OPSKRIFTSDATA HER :(",
        "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "DER ER ENDNU INGEN RENGØRINGSDATA HER :(",
        "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "DER ER ENDNU INGEN HÆNDELSESDATA HER :(",
        "ID": "ID",
        "equipment.Hora": "Tid",
        "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "MEST FOREKOMMENDE HÆNDELSER PÅ UDSTYRET I PERIODEN",
        "equipment.hour": "t",
        "equipment.minutes": "min",
        "equipment.date format": "DD/MM/ÅÅÅÅ",
        "equipment.preparada": "tilberedt",
        "equipment.vezes": "gange",
        "equipment.vez": "gang",
        "equipment.Ver": "Vis",
        "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Data opbevares af platformen så længe, det er nødvendigt for support, vedligeholdelse og videreudvikling af produkterne.",
        "equipment.Ligado": "Tændt",
        "equipment.Desligado": "Slukket",
        "equipment.CAN ERROR": "CAN-fejl",
        "equipment.CAMERA SENSOR ERROR": "Fejl i kammersensor",
        "equipment.STEAM/RI SENSOR ERROR": "Fejl i RI-sensor",
        "equipment.PROBE 1 ERROR": "Advarsel for føler 1",
        "equipment.PROBE 2 ERROR": "Advarsel for føler 2",
        "equipment.PROBE 3 ERROR": "Advarsel for føler 3",
        "equipment.PROBE 4 ERROR": "Advarsel for føler 4",
        "equipment.PROBE 5 ERROR": "Advarsel for føler 5",
        "equipment.PROBE 6 ERROR": "Advarsel for føler 6",
        "equipment.GENERAL PROBE ERROR": "Generel følerfejl",
        "equipment.WATER LACK ERROR": "Advarsel om manglende vand",
        "equipment.HIGH PANEL TEMPERATURE ERROR": "Advarsel om høj paneltemperatur",
        "equipment.FREQUENCY INVERTER GENERAL ERROR": "Generel fejl i frekvensomformer",
        "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Kommunikationsadvarsel for frekvensomformer",
        "equipment.FREQUENCY INVERTER STATUS ERROR": "Statusfejl i frekvensomformer",
        "equipment.CLEANING NOT COMPLETED ERROR": "Advarsel om ufuldstændig rengøring",
        "equipment.MAGNETRON ERROR": "Magnetronadvarsel",
        "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Fejl i udstyrets model",
        "equipment.BOARD TEMPERATURE SENSOR ERROR": "Advarsel om temperaturføler på printkort",
        "equipment.ENERGY MODULE ERROR": "Fejl i energimodul",
        "equipment.POWER BOARD I2C BUS ERROR": "Fejl på Power-kort",
        "equipment.GAS SYSTEM ERROR": "Gasfejl",
        "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Fejl: meget høj paneltemperatur",
        "equipment.POWER ON": "Tændt",
        "equipment.POWER OFF": "Slukket",
        "equipment.DOOR OPENED": "Dør åbnet",
        "equipment.DOOR CLOSED": "Dør lukket",
        "equipment.CLEANING CANCELED ERROR": "Rengøring annulleret af brugeren",
        "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN blev ikke fundet. Kontrollér den, og prøv igen",
        "equipment.Ultracongeladores": "Blæstkølere",
        "equipment.PIN já vinculado a outra conta": "PIN-koden er allerede knyttet til en anden konto",
        "equipment.Equipamento já cadastrado nesta conta": "Udstyret er allerede registreret på denne konto",
        "equipment.Não foi possível validar o PIN. Tente novamente": "PIN-koden kunne ikke valideres. Prøv igen",
        "equipment.Modelo definido pelo equipamento": "Defineret af udstyret",
        "equipment.Número de série offline inválido": "Indtast syv cifre uden mellemrum eller indledende nul",
        "equipment.Número de série já cadastrado": "Serienummeret er allerede registreret",
        "equipment.Online": "Tændt",
        "equipment.Offline": "Slukket",
        "equipment.Exibir apenas eventos": "Vis kun hændelser",
        "equipment.Endereço": "Adresse",
        "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Udstyr tilsluttet platformen",
        "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Udstyr frakoblet platformen",
        "equipment.MENU RECEIVED FROM THE PLATFORM": "Menu fra platformen accepteret af brugeren",
        "equipment.MENU REJECTED BY THE USER": "Menu fra platformen afvist af brugeren",
        "equipment.CONNECTED TO THE INTERNET": "Tilsluttet internettet",
        "equipment.DISCONNECTED FROM THE INTERNET": "Frakoblet internettet",
        "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Desværre findes der ingen kompatible versioner til dette udstyr, som understøtter dataoverførsel.",
        "equipment.O equipamento": "Udstyret",
        "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "skal opdateres til den nyeste softwareversion for at kunne sende data til platformen",
        "equipment.Versão do seu equipamento": "Version på dit udstyr",
        "equipment.Versão disponível": "Tilgængelig version",
        "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Vælg nedenfor, hvordan du vil sende opdateringen til dit udstyr",
        "equipment.Salvar no dispositivo": "Gem på enheden",
        "equipment.Enviar pela internet": "Send via internettet",
        "equipment.Cliente": "Kunde",
        "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "SERIENUMMER IKKE FUNDET",
        "equipment.BUSCAR": "SØG",
        "equipment.ACESSADOS RECENTEMENTE": "SENEST ÅBNEDE",
        "equipment.SEM BUSCAS RECENTES": "INGEN SENESTE SØGNINGER",
        "equipment.description.SEM BUSCAS RECENTES": "Brug serienummeret til at søge efter udstyr.",
        "equipment.Procurar equipamento pelo número de série": "Søg efter udstyr via serienummer",
        "equipment.AIR FILTER CLEANING COMPLETED": "Rengøring af luftfilter fuldført",
        "equipment.AIR FILTER CLEANING REJECTED": "Rengøring af luftfilter afvist",
        "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Rengøring af katalytisk filter fuldført",
        "equipment.CATALYTIC FILTER CLEANING REJECTED": "Rengøring af katalytisk filter afvist",
        "equipment.Endereço (rua, avenida, rodovia)": "Adresse (gade, allé, vej)",
        "equipment.Nº/Km": "Nr./Km",
        "equipment.ID do equipamento": "Udstyrs-ID",
        "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "Alt udstyr skal være tilknyttet en gruppe. Vælg en gruppe på listen, eller opret en ny ved at klikke på + Opret gruppe.",
        "equipment.Nomeie seu forno": "Navngiv din ovn",
        "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "For at se PIN-koden skal du åbne IOK Virtual Platform i udstyrets indstillinger.",
        "equipment.Vinculação IOK": "IOK-tilknytning",
       "equipment.Preparações": "Tilberedninger",
        "equipment.recipeTable.recipe": "Opskrift",
        "equipment.recipeTable.origin": "Opr.",
        "equipment.recipeTable.executions": "Udf.",
        "equipment.recipeTable.lastExecution": "Seneste udførelse",
        "equipment.Última preparação": "Seneste tilberedning",
        "equipment.localização": "lokation",
        "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "DER ER ENDNU INGEN REGISTREREDE LOKATIONER :(",
        "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Klik på knappen øverst til højre for at tilføje lokationer.",
        "equipment.Procurar empresa ou local": "Søg efter virksomhed eller lokation",
        "equipment.Adicionar localização": "Tilføj lokation",
        "equipment.Adicionar": "Tilføj",
        "equipment.espaço": "Område",
        "equipment.local": "Lokation",
        "equipment.EXCLUIR LOCALIZAÇÃO": "SLET LOKATION",
        "equipment.Você deseja excluir esta localização?": "Ønsker du at slette denne lokation?",
        "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "Hvis du gør dette, vil de tilknyttede enheder ikke længere vise nogen lokation, og det vil være nødvendigt at angive en ny lokation for dem.",
        "equipment.Localização deletada com sucesso!": "Lokation slettet med succes!",
        "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Fejl ved sletning af lokation. Prøv igen senere",
        "equipment.Não foi possivel deletar a localização": "Det var ikke muligt at slette lokationen",
        "equipment.Localização adicionada com sucesso!": "Lokation tilføjet med succes!",
        "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "Det var ikke muligt at tilføje lokationen. Prøv igen senere",
        "equipment.Nome do espaço": "Navn på område",
        "equipment.Informe o nome do espaço": "Angiv navnet på området",
        "equipment.Preencha o nome do espaço": "Udfyld navnet på området",
        "equipment.país": "Land",
        "equipment.informe o país": "Angiv landet",
        "equipment.preencha o país": "Udfyld landet",
        "equipment.Localização editada com sucesso!": "Lokation redigeret med succes!",
        "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "Det var ikke muligt at redigere lokationen. Prøv igen senere",
        "equipment.Editar localização": "Rediger lokation",
        "equipment.Pico de preparações": "Højeste antal tilberedninger",
        "equipment.informações da semana": "ugens oplysninger",
        "equipment.horários de pico": "spidsbelastningstider",
        "equipment.horário de pico": "spidsbelastningstid",
        "equipment.preparações do dia": "dagens tilberedninger",
        "equipment.Horário": "Tid",
        "equipment.dia selecionado": "valgt dag",
        "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "Korrekt daglig rengøring af ovnen hjælper med at sikre korrekt drift og har betydning for garantien.",
        "equipment.Total de limpezas realizadas:": "Samlet antal udførte rengøringer:",
        "equipment.Limpezas não concluídas:": "Ikke afsluttede rengøringer:",
        "equipment.Desde a vinculação do forno a IOK": "Siden ovnen blev tilknyttet IOK",
        "equipment.Equipamento ligado há:": "Udstyret har været tændt i:",
        "equipment.Total de receitas preparadas:": "Samlet antal tilberedte opskrifter:",
        "equipment.Receitas preparadas": "Tilberedte opskrifter",
        "equipment.Aberturas de porta": "Døråbninger",
        "equipment.Desde a última vez que o forno foi ligado": "Siden ovnen sidst blev tændt",
        "equipment.Preparação": "Tilberedning",
        "equipment.Nenhuma localização criada": "Ingen lokation oprettet",
        "equipment.Acesso remoto": "Fjernadgang",
        "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Angiv ID'et på den virksomhed, der skal have fjernadgang til din ovn. Brug ; til at adskille flere ID'er.",
        "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "Fjernadgang giver de valgte virksomheder mulighed for at sende menuer og opdateringer til dit udstyr.",
        "equipment.Concedo acesso remoto à Prática oficial.": "Jeg giver officiel Prática fjernadgang.",
        "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Ønsker du at vælge andre enheder, der er tilknyttet din konto, for også at give dem fjernadgang?",
        "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Vælg nedenfor de enheder, som du ønsker at give fjernadgang til",
        "equipment.Acesso remoto concedido com sucesso!": "Fjernadgang givet med succes!",
        "equipment.Selecione pelo menos um equipamento": "Vælg mindst én enhed",
        "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "Det var ikke muligt at redigere enhederne. Prøv igen senere",
        "equipment.Solicitar atendimento": "Anmod om service",
        "equipment.Relate um problema": "Beskriv et problem",
        "equipment.Descreva aqui o problema de seu equipamento": "Beskriv problemet med dit udstyr her",
        "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "Det var ikke muligt at sende din serviceanmodning. Prøv igen senere",
        "equipment.Solicitação técnica enviada com sucesso!": "Teknisk serviceanmodning sendt med succes!",
        "equipment.Enviar": "Send",
        "equipment.Solicitação de atendimento": "Serviceanmodning",
        "equipment.Informe o problema de seu equipamento": "Beskriv problemet med dit udstyr",
        "equipment.Informações do magnetron": "Magnetronoplysninger",
        "equipment.Vida útil aproximada": "Anslået levetid",
        "equipment.MAGNETRON USAGE HOURS": "Magnetronens driftstimer",
        "equipment.Atendimento": "Service",
        "equipment.Eventos mais ocorridos no equipamento durante o período": "Hyppigst forekommende hændelser på udstyret i perioden",
        "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "UDSTYR UDEN SERIENUMMER",
        "equipment.Filtros": "Filtre",
        "equipment.Filtrar": "Filtrer",
        "equipment.Limpar filtros": "Ryd filtre",
        "equipment.Procurar por modelo, versão ou país": "Søg efter model, version eller land",
        "equipment.Procurar equipamento, NS, modelo, versão ou país": "Søg efter udstyr, serienummer, model, version eller land",
        "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "Følgende ID'er tilhører ikke en virksomhed af typen 'Distributør' og er blevet fjernet",
        "equipment.BAIXAR VERSÕES": "DOWNLOAD VERSIONER",
        "equipment.Compatível com todas as versões da IHM.": "Kompatibel med alle IHM-versioner.",
        "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Kun kompatibel med Power-version 2.0.0C.",
        "equipment.Procurar evento": "Søg efter hændelse",
        "equipment.Forno conectado": "Ovn tilsluttet",
        "equipment.Limpeza de filtro de ar": "Rengøring af luftfilter",
        "equipment.Limpeza de filtro catalítico": "Rengøring af katalytisk filter",
        "equipment.Limpeza realizada": "Rengøring udført",
        "equipment.Limpeza recomendada": "Anbefalet rengøring",
        "equipment.Forno ligado": "Ovn tændt",
        "equipment.Inversor de frequência": "Frekvensomformer",
        "equipment.Temperatura de painel": "Paneltemperatur",
        "equipment.Sensor da câmara": "Kammersensor",
        "equipment.Magnetron": "Magnetron",
        "equipment.Power": "Power",
        "equipment.Informações de menu": "Menuoplysninger",
        "equipment.Limpeza": "Rengøring",
        "equipment.O equipamento já está utilizando a versão mais recente do software.": "Udstyret bruger allerede den nyeste softwareversion.",
        "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Bemærk: Beregningen af magnetronens levetid tager ikke højde for brugstid før version F1.1.0.",
        "equipment.Equipamentos com erro": "Udstyr med fejl",
        "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.":
        "Snart får du adgang til vigtige data sendt fra ovnen, såsom spidsbelastningstider, de mest tilberedte opskrifter, rengøringshistorik, registrerede hændelser og meget mere! Husk altid at holde dit udstyr opdateret med de nyeste versioner, der er tilgængelige på platformen.",
        "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.":
        "For at rengøringen registreres på udstyret og sendes til platformen, er det nødvendigt at følge hele rengøringsproceduren trin for trin på ovnen. Det er ikke obligatorisk at se videoer til trinnene, når de er tilgængelige.",
        "equipment.Horas de uso": "Driftstimer",
        "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "Optællingen af magnetronens driftstimer foretages fra version F1.0.6.",
        "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "Softwareopdateringen tager cirka 15 minutter. Under processen genstarter ovnen og viser en blå skærm, indtil opdateringen er fuldført. For at undgå fejl skal ovnen forblive tændt og tilsluttet internettet. Hvis du vælger at opdatere via USB-nøgle, må du ikke fjerne den, før opdateringen er afsluttet.",
        'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "Udstyr {name} med software {version} skal opdateres via USB. Softwareopdateringen tager cirka 15 minutter. Under processen genstarter ovnen og viser en blå skærm, indtil opdateringen er fuldført. For at undgå fejl skal ovnen forblive tændt og tilsluttet internettet. Hvis du vælger at opdatere via USB-nøgle, må du ikke fjerne den, før opdateringen er afsluttet.",
        "equipment.Observação": "Bemærk:",
        'equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.': "For versioner ST2.0.0 og højere vil opdateringer via platformen (Wi-fi) fortsat være tilgængelige som normalt.",
        "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Her finder du generelle oplysninger om udstyret;",
        "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Ved at klikke på disse knapper kan du anmode om service til din ovn og eksportere dine data til Excel-regneark;",
        "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "I felterne nedenfor finder du detaljerede oplysninger om tilberedning af opskrifter;",
        "equipment.Horário de pico;": "Spidsbelastningstid;",
        "equipment.Informações referentes a higienização;": "Oplysninger om rengøring;",
        "equipment.E histórico de eventos;": "Og hændelseshistorik;",
        "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Husk, at du skal vælge den periode, du ønsker at se data for. Det kan du gøre ved at klikke på kalenderen i felterne og vælge filtre.",
        "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Downloader filen... Den vil snart være tilgængelig!",
        "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "Optællingen af magnetronens driftstimer foretages fra version F1.1.0.",
        "equipment.Data de fabricação": "Fremstillingsdato",
        "equipment.manutenção": "vedligeholdelse",
        "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.":
        "Når du søger efter og finder et serienummer, oprettes der en midlertidig forbindelse direkte til ovnen, så vedligeholdelsesdata kan deles. Disse data gemmes ikke på platformen, og der skal derfor foretages en ny søgning, hver gang du ønsker at få adgang til dem.",
        "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "ANGIV ET SERIENUMMER, OG KLIK PÅ SØG",
        "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.":
        "Kun modellerne FIT Express / FIT Single Mag / FIT XL med softwareversion F2.1.0 sender vedligeholdelsesdata. Oplysningerne, især tællerværdierne, registreres fra denne version og frem.",
        "equipment.Procurar número de série": "Søg efter serienummer",
        "equipment.ENCERRAR SESSÃO": "AFSLUT SESSION",
        "equipment.Alerta": "Advarsel",
        "equipment.Local": "Lokation",
        "equipment.Software": "Software",
        "equipment.Forno sem limpeza há": "Ovn uden rengøring i",
        "equipment.Horário de pico": "Spidsbelastningstid",
        "equipment.HP": "SP",
        "equipment.RECIPE STARTED": "Opskrift startet",
        "equipment.RECIPE CANCELED": "Opskrift annulleret af brugeren",
        "equipment.RECIPE COMPLETED": "Opskrift gennemført",
        "equipment.DOOR OPENED RECIPE": "Dør åbnet under opskriften",
        "equipment.DOOR CLOSED RECIPE": "Dør lukket under opskriften",
        "equipment.Receitas iniciadas": "Startede opskrifter",
        "equipment.Receitas concluídas": "Fuldførte opskrifter",
        "equipment.Receitas interrompidas": "Afbrudte opskrifter",
        "equipment.Total de receitas concluídas:": "Samlet antal fuldførte opskrifter:",
        "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "SAMLET ANTAL AFBRUDTE OPSKRIFTER",
        "equipment.DOWNLOAD_PROGRESS": "DOWNLOADER FIL... VENT VENLIGST, FREMSKRIDT: {progress}%",
        "equipment.Informe o número de série do forno": "Angiv ovnens serienummer",
        "equipment.preencha o número de série do forno": "Udfyld ovnens serienummer",
        "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "SERIENUMMER IKKE REGISTRERET",
        "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Serienummer blev ikke fundet. Kontroller det, og prøv igen.",
        "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Inden opdateringen påbegyndes, skal du sikkerhedskopiere de opskrifter, der er gemt på udstyret, for at sikre dataintegriteten. Sikkerhedskopien kan oprettes via USB-nøgle eller platformen. Dette gør det muligt at gendanne oplysningerne i tilfælde af datatab.",
        "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Menu modtaget fra platformen via tvungen opdatering",
        "equipment.Nome da receita não encontrado": "Opskriftens navn blev ikke fundet",
        "equipment.passos": "{count, plural, one {trin} other {trin}}",
        "equipment.minAbbreviation": "min",
        "equipment.secAbbreviation": "sek",
        "equipment.Configurações": "Indstillinger",
        "equipment.Tempo de preaquecimento": "Forvarmningstid",
        "equipment.Formato de data": "Datoformat",
        "equipment.Formato de hora": "Tidsformat",
        "equipment.Unidade de temperatura": "Temperaturenhed",
        "equipment.Aquecer/dourar mais": "Opvarm/brun mere",
        "equipment.Fabricante": "Producent",
        "equipment.Voltagem": "Spænding",
        "equipment.Introdução": "Introduktion",
        "equipment.Modelo": "Model",
        "equipment.Motor": "Motor",
        "equipment.Hostname": "Værtsnavn",
        "equipment.STATUS DA OPERAÇÃO": "DRIFTSSTATUS",
        "equipment.ÚLTIMA LIMPEZA": "SIDSTE RENGØRING",
        "equipment.VELOCIDADE DO MOTOR": "MOTORHASTIGHED",
        "equipment.TENSÃO ATUAL": "AKTUEL SPÆNDING",
        "equipment.Sensores e periféricos": "Sensorer og periferiudstyr",
        "equipment.Contadores": "Tællere",
        "equipment.HORAS DE USO DO MOTOR": "MOTORENS DRIFTSTIMER",
        "equipment.HORAS DE USO DO MAGNETRON": "MAGNETRONENS DRIFTSTIMER",
        "equipment.ABERTURAS DE PORTA": "DØRÅBNINGER",
        "equipment.ATUAÇÃO DO RELE DA POWER": "POWER-RELÆETS AKTIVERINGER",
        "equipment.ATUAÇÃO DO SENSOR DE PORTA": "DØRSENSORAKTIVERINGER",
        "equipment.RECEITAS EXECUTADAS": "TILBEREDTE OPSKRIFTER",
        "equipment.LIMPEZAS EXECUTADAS": "UDFØRTE RENGØRINGER",
        "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "DRIFTSTIMER FOR KATALYTISK FILTER",
        "equipment.HORAS DE USO DO FILTRO DE AR": "DRIFTSTIMER FOR LUFTFILTER",
        "equipment.CORRENTE DO MAGNETRON": "MAGNETRONSTRØM",
        "equipment.Erros": "Fejl",
        "equipment.status online": "online status",
        "equipment.status offline": "offline status",
        "equipment.software accepted": "software accepteret",
        "equipment.menu accepted": "menu accepteret",
        "equipment.software pending": "software afventer",
        "equipment.menu pending": "menu afventer",
        "equipment.software refused": "software afvist",
        "equipment.menu refused": "menu afvist",
        "equipment.Ativado": "Aktiveret",
        "equipment.Desativado": "Deaktiveret",
        "equipment.Cozinhando": "Tilbereder",
        "equipment.Pré-aquecendo": "Forvarmer",
        "equipment.Em espera": "Standby",
        "equipment.Limpando": "Rengør",
        "equipment.horas": "timer",
        "equipment.Erro CAN": "CAN-fejl",
        "equipment.Erro no sensor de câmara": "Fejl i kammersensor",
        "equipment.Alerta de temperatura alta no painel": "Advarsel om høj paneltemperatur",
        "equipment.Erro de temperatura alta no painel": "Fejl: høj paneltemperatur",
        "equipment.Alerta de comunicação no inversor de frequência": "Advarsel om kommunikation med frekvensomformer",
        "equipment.Alerta de status no inversor de frequência": "Advarsel om status på frekvensomformer",
        "equipment.Alerta na corrente do magnetron": "Advarsel om magnetronstrøm",
        "equipment.Erro no modelo do equipamento": "Fejl i udstyrsmodel",
        "equipment.Erro no módulo de energia": "Fejl i energimodul",
        "equipment.Erro I2C": "I2C-fejl",
        "equipment.Erro de temperatura alta na placa": "Fejl: høj temperatur på printkort",
        "equipment.Fechado": "Lukket",
        "equipment.Aberto": "Åben",
        "equipment.Câmara": "Kammer",
        "equipment.Placa": "Printkort",
        "equipment.Tensão": "Spænding",
        "equipment.Corrente da placa": "Printkortets strøm",
        "equipment.Velocidade do motor": "Motorhastighed",
        "equipment.Rele da resistência": "Varmelegemets relæ",
        "equipment.Rele de curto circuito": "Kortslutningsrelæ",
        "equipment.Ventilador radial": "Radialventilator",
        "equipment.Led vermelho": "Rød LED",
        "equipment.Led verde": "Grøn LED",
        "equipment.Led azul": "Blå LED",
        "equipment.Erro": "Fejl",
        "equipment.Sensor": "Sensor",
        "equipment.Valor": "Værdi",
        "equipment.Manutenção da temperatura": "Temperaturvedligeholdelse",
        "equipment.Manutenção": "Vedligeholdelse",
        "equipment.Esfriando": "Nedkøler",
        "equipment.CEILING SENSOR ERROR": "Fejl i loftsensor",
        "equipment.BALLAST SENSOR ERROR": "Fejl i bagestenssensor",
        "equipment.VAPORIZER SENSOR ERROR": "Fejl i fordamperens sensor",
        "equipment.EQUIPMENT CONSUMPTION": "Forbrug",
        "equipment.Sensores": "Sensorer",
        "equipment.Falta de água": "Manglende vand",
        "equipment.Executando Receita": "Tilbereder opskrift",
        "equipment.Executando Limpeza": "Udfører rengøring",
        "equipment.Dia": "Dag",
        "equipment.Semana": "Uge",
        "equipment.Mês": "Måned",
        "equipment.Tempo": "Tid",
        "equipment.Segunda": "Mandag",
        "equipment.Terça": "Tirsdag",
        "equipment.Quarta": "Onsdag",
        "equipment.Quinta": "Torsdag",
        "equipment.Sexta": "Fredag",
        "equipment.Sábado": "Lørdag",
        "equipment.Domingo": "Søndag",
        "equipment.CONSUMO ESTIMADO": "ESTIMERET FORBRUG",
        "equipment.CONSUMO ATUAL": "AKTUELT FORBRUG",
        "equipment.ECONOMIA COM MODO ECO": "BESPARELSE MED ECO-TILSTAND",
        "equipment.MÉDIA SEMANAL": "UGENTLIGT GENNEMSNIT",
        "equipment.MÉDIA MENSAL": "MÅNEDLIGT GENNEMSNIT",
        "equipment.Consumo de energia": "Energiforbrug",
        "equipment.CONSUMO ACUMULADO": "AKKUMULERET FORBRUG",
        "equipment.MÉDIA DIÁRIA": "DAGLIGT GENNEMSNIT",
        "equipment.mês selecionado": "valgt måned",
        "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Denne værdi repræsenterer det samlede energiforbrug for hver time på dagen.",
        "equipment.Este valor representa a soma total dos consumos de cada dia.": "Denne værdi repræsenterer det samlede energiforbrug for hver dag.",
        "equipment.Este valor representa a soma total dos consumos de cada semana.": "Denne værdi repræsenterer det samlede energiforbrug for hver uge.",
        "equipment.Este valor representa a soma total dos consumos de cada mês.": "Denne værdi repræsenterer det samlede energiforbrug for hver måned.",
        "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Denne værdi repræsenterer det gennemsnitlige energiforbrug pr. time og giver dermed et estimat baseret på dit forbrug.",
        "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Denne værdi repræsenterer det gennemsnitlige energiforbrug pr. dag og giver dermed et estimat baseret på dit forbrug.",
        "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Denne værdi repræsenterer det gennemsnitlige ugentlige energiforbrug og giver dermed et estimat baseret på dit forbrug.",
        "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Denne værdi repræsenterer det gennemsnitlige energiforbrug for de seneste to måneder og giver dermed et estimat baseret på dit forbrug.",
        "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Denne værdi repræsenterer den samlede energibesparelse pr. time ved brug af Eco-tilstand.",
        "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Denne værdi repræsenterer den samlede energibesparelse pr. dag ved brug af Eco-tilstand.",
        "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Denne værdi repræsenterer den samlede ugentlige energibesparelse ved brug af Eco-tilstand.",
        "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Denne værdi repræsenterer den samlede månedlige energibesparelse ved brug af Eco-tilstand.",
        "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Denne værdi repræsenterer det gennemsnitlige energiforbrug for de seneste 7 dage, eksklusive den aktuelle dag.",
        "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Denne værdi repræsenterer det gennemsnitlige energiforbrug for de seneste 4 uger.",
        "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Denne værdi repræsenterer det gennemsnitlige energiforbrug for de seneste 2 måneder, eksklusive den aktuelle måned.",
        "equipment.Lista de consumo de energia": "Liste over energiforbrug",
        "equipment.Período": "Periode",
        "equipment.Consumo (kWh)": "Forbrug (kWh)",
        "equipment.Economia com ECO (kWh)": "Besparelse med ECO (kWh)",
        "equipment.Total": "I alt",
        "equipment.Sensor de RI": "RI-sensor",
        "equipment.HUMIDITY SENSOR ERROR": "Fejl i fugtighedssensor",
        "equipment.TEMPERATURE SENSOR ERROR": "Fejl i temperatursensor",
        "equipment.WATER FILTER CLEANING COMPLETED": "Udskiftning af vandfilter fuldført",
        "equipment.WATER FILTER CLEANING REJECTED": "Udskiftning af vandfilter afvist",
        "equipment.HOOD TURNED ON": "Emhætte tændt",
        "equipment.HOOD TURNED OFF": "Emhætte slukket",
        "equipment.AUTOMATIC PREHEATING REJECTED": "Automatisk forvarmning afvist",
        "equipment.Receitas Forno": "Ovnopskrifter",
        "equipment.Receitas Fermentadora": "Hæveskabsopskrifter",
        "equipment.média diária": "dagligt gennemsnit",
        "equipment.média de execução diária": "gennemsnitligt antal daglige tilberedninger",
        "equipment.FERMENTADORA": "HÆVESKAB",
        "equipment.FORNO": "OVN",
        "equipment.DIA": "DAG",
        "equipment.Baixado": "Downloadet",
        "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia.": "Daglig rengøring af udstyret hjælper med at sikre korrekt funktion og har betydning for garantien.",
        "equipment.Desde a vinculação do equipamento ao IOK": "Siden udstyret blev tilknyttet IOK",
        "equipment.Total desde a vinculação do equipamento ao IOK": "I alt siden udstyret blev tilknyttet IOK",
        "equipment.Receitas do forno": "Ovnopskrifter",
        "equipment.Receitas da fermentadora": "Hæveskabsopskrifter",
        "equipment.FERM.": "HÆV.",
        "equipment.Fermentadora": "Hæveskab",
        "equipment.Coifa": "Emhætte",
        "equipment.Preaquecimento automático": "Automatisk forvarmning",
        "equipment.nivel": "niveau",
        "equipment.Fermentadora ligada": "Hæveskab tændt",
        "equipment.Fermentadora desligada": "Hæveskab slukket",
        "equipment.Forno desligado": "Ovn slukket",
        "equipment.Equipamento ligado": "Udstyr tændt",
        "equipment.Equipamento desligado": "Udstyr slukket",
        "equipment.visualizar haccp": "vis HACCP",
        "equipment.HACCP": "HACCP",
        "equipment.Atualizar Equip.": "Opdater udstyr",
        "equipment.Consumo de agua por receita": "Vandforbrug pr. opskrift",
        "equipment.Consumo de energia por receita": "Energiforbrug pr. opskrift",
        "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "DER ER ENDNU INGEN DATA OM VANDFORBRUG PR. OPSKRIFT :(",
        "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "DER ER ENDNU INGEN DATA OM ENERGIFORBRUG PR. OPSKRIFT :(",
        "equipment.LITROS CONSUMIDOS NO DIA": "LITER FORBRUGT I DAG",
        "equipment.ENERGIA CONSUMIDA NO DIA": "ENERGI FORBRUGT I DAG",
        "equipment.CONSUMO ACUMULADO SEMANAL": "AKKUMULERET UGENTLIGT FORBRUG",
        "equipment.CONSUMO ACUMULADO MENSAL": "AKKUMULERET MÅNEDLIGT FORBRUG",
        "equipment.Receitas": "Opskrifter",
        "equipment.Consumo (L)": "Forbrug (L)",
        "equipment.Exec. dia - (L)": "Tilb. dag - (L)",
        "equipment.Exec. semana - (L)": "Tilb. uge - (L)",
        "equipment.Exec. mês - (L)": "Tilb. måned - (L)",
        "equipment.Exec. dia - (kWh)": "Tilb. dag - (kWh)",
        "equipment.Exec. semana - (kWh)": "Tilb. uge - (kWh)",
        "equipment.Exec. mês - (kWh)": "Tilb. måned - (kWh)",
        "equipment.Agua consumida (litros)": "Forbrugt vand (liter)",
        "equipment.Energia consumida (kWh)": "Forbrugt energi (kWh)",
        "equipment.temperatura da câmara": "Kammertemperatur",
        "equipment.temperatura do vapor": "Damptemperatur",
        "equipment.último evento listado": "Sidst viste hændelse",
        "equipment.temperatura da sonda": "Sondetemperatur",
        "equipment.porta": "Dør",
        "equipment.temperatura": "Temperatur",
        "equipment.temperatura atual": "Aktuel temperatur",
        "equipment.média de oscilação diária": "Gennemsnitlig daglig temperaturvariation",
        "equipment.oscilação diária da temperatura": "Daglig temperaturvariation",
        "equipment.temperature.sectionTitle": "Temperatur",
        "equipment.temperature.currentChamber": "AKTUEL KAMMERTEMPERATUR:",
        "equipment.temperature.currentProbe": "AKTUEL SONDETEMPERATUR:",
        "equipment.temperature.currentSteam": "AKTUEL DAMPTEMPERATUR:",
        "equipment.temperature.dailyOscillation": "Daglig temperaturvariation",
        "equipment.temperature.chamberShort": "Kammer",
        "equipment.temperature.probeShort": "Sonde",
        "equipment.temperature.axisLabel": "Temperatur {unit}",
        "equipment.temperature.dailyAverage": "DAGLIGT GENNEMSNIT",
        "equipment.temperature.weeklyAverage": "UGENTLIGT GENNEMSNIT",
        "equipment.temperature.monthlyAverage": "MÅNEDLIGT GENNEMSNIT",
        "equipment.temperature.lastListedEvent": "Senest viste hændelse",
        "equipment.temperature.door": "Dør",
        "equipment.temperature.open": "ÅBEN",
        "equipment.temperature.closed": "LUKKET",
        "equipment.temperature.defineTimeRange": "Angiv tidsinterval:",
        "equipment.temperature.until": "til",
        "equipment.cleaningType.smart": "Intelligent rengøring",
        "equipment.cleaningType.light": "Let rengøring",
        "equipment.cleaningType.medium": "Mellem rengøring",
        "equipment.cleaningType.heavy": "Grundig rengøring",
        "equipment.cleaningType.decalcifying": "Afkalkningsrengøring",
        "equipment.cleaningType.security": "Sikkerhedsrengøring",
        "equipment.cleaningType.rinse": "Skylning",
        "equipment.cleaningType.custom": "Tilpasset rengøring",
        "equipment.cleaningTypeShort.smart": "Intelligent",
        "equipment.cleaningTypeShort.light": "Let",
        "equipment.cleaningTypeShort.medium": "Mellem",
        "equipment.cleaningTypeShort.heavy": "Grundig",
        "equipment.cleaningTypeShort.decalcifying": "Afkalkning",
        "equipment.cleaningTypeShort.security": "Sikkerhed",
        "equipment.cleaningTypeShort.rinse": "Skylning",
        "equipment.cleaningTypeShort.custom": "Tilpasset",
        "equipment.gerar gráficos": "generer grafer",
        "equipment.Realizada": "Udført",
        "equipment.Recomendada": "Anbef.",
        "equipment.Dias da semana": "Ugedage",
        "equipment.Horário 24h": "24-timers format",
        "equipment.seg": "Man",
        "equipment.ter": "Tir",
        "equipment.qua": "Ons",
        "equipment.qui": "Tor",
        "equipment.sex": "Fre",
        "equipment.sab": "Lør",
        "equipment.dom": "Søn",
        "equipment.Desconhecido": "Ukendt",
        "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(": "DER ER ENDNU INGEN DATA OM ENERGIFORBRUG HER :(",
        "equipment.monthShort.Jan": "Jan",
        "equipment.monthShort.Fev": "Feb",
        "equipment.monthShort.Mar": "Mar",
        "equipment.monthShort.Abr": "Apr",
        "equipment.monthShort.Mai": "Maj",
        "equipment.monthShort.Jun": "Jun",
        "equipment.monthShort.Jul": "Jul",
        "equipment.monthShort.Ago": "Aug",
        "equipment.monthShort.Set": "Sep",
        "equipment.monthShort.Out": "Okt",
        "equipment.monthShort.Nov": "Nov",
        "equipment.monthShort.Dez": "Dec",
        "equipment.settingsChange.category": "Parameterændring",
        "equipment.settingsChange.factoryTitle": "Ændring af teknisk parameter",
        "equipment.settingsChange.userTitle": "Ændring af brugerparameter",
        "equipment.settingsChange.changedTo": "{label} ændret til {value}",
        "equipment.settingsChange.hardResetExecuted": "Hard reset udført",
        "equipment.settingsChange.userFactoryResetExecuted": "Brugerens fabriksnulstilling udført",
        "equipment.settingsChange.magSensorEnabled": "magnetronsensor",
        "equipment.settingsChange.serialNumber": "serienummer",
        "equipment.settingsChange.manufactureDate": "fremstillingsdato",
        "equipment.settingsChange.inverterType": "invertertype",
        "equipment.settingsChange.preHeatMotorSpeed": "motorhastighed for forvarmning",
        "equipment.settingsChange.voltage": "spænding",
        "equipment.settingsChange.oemModeEnabled": "OEM-tilstand",
        "equipment.settingsChange.controlDoor": "dørstyring",
        "equipment.settingsChange.hardReset": "Hard reset",
        "equipment.settingsChange.preHeatTemperatureOne": "forvarmningstemperatur 1",
        "equipment.settingsChange.preHeatTemperatureTwo": "forvarmningstemperatur 2",
        "equipment.settingsChange.preHeatTime": "forvarmningstid",
        "equipment.settingsChange.preHeatTwoEnabled": "forvarmning 2",
        "equipment.settingsChange.userFactoryReset": "Brugerens fabriksnulstilling",
        "equipment.settingsChange.enableManualMode": "manuel tilstand",
        "equipment.settingsChange.enableFavorites": "favoritter",
        "equipment.settingsChange.enableHeatBrown": "opvarm/brun mere",
        "equipment.settingsChange.enableRepeatRecipe": "gentag opskrift",
        "equipment.settingsChange.enableOperatorMode": "operatørtilstand",
        "equipment.settingsChange.enableAutoImport": "automatisk import",
        "equipment.settingsChange.enableRecipePreRunMessage": "besked før opskriftsstart",
        "equipment.settingsChange.controlDoorTwoInputs": "2 indgange",
        "equipment.settingsChange.controlDoorThreeInputs": "3 indgange",
        
        //LOJAS
        "store.Procurar loja": "Søg efter butik",
        "store.Excluir": "Slet",
        "store.Editar": "Rediger",
        "store.nome": "Navn",
        "store.equipamentos": "Udstyr",
        "store.Equipamentos vinculados": "Tilknyttet udstyr",
        "store.cidade": "By",
        "store.estado": "Region",
        "store.salvar": "gem",
        "store.cadastrar loja": "registrer butik",
        "store.Nome fantasia": "Butiksnavn",
        "store.Preencha o nome da loja": "Udfyld butikkens navn",
        "store.CNPJ": "CNPJ",
        "store.Preencha o CNPJ da loja": "Udfyld butikkens CNPJ",
        "store.CEP": "Postnummer",
        "store.Preencha o CEP da loja": "Udfyld butikkens postnummer",
        "store.Informe o nome fantasia": "Angiv butiksnavnet",
        "store.Cidade": "By",
        "store.Informe a cidade": "Angiv byen",
        "store.Preencha a cidade": "Udfyld byen",
        "store.UF": "Region",
        "store.Preencha o UF da loja": "Udfyld butikkens region",
        "store.Bairro": "Bydel",
        "store.Informe o bairro": "Angiv bydelen",
        "store.Preencha o bairro da loja": "Udfyld butikkens bydel",
        "store.Endereço": "Adresse",
        "store.Informe o endereço": "Angiv adressen",
        "store.Preencha o endereço da loja": "Udfyld butikkens adresse",
        "store.Nº": "Nr.",
        "store.Preencha o número": "Udfyld nummeret",
        "store.Loja cadastrada com sucesso": "Butik registreret med succes",
        "store.Erro ao adicionar loja. Tente novamente":
        "Fejl ved tilføjelse af butik. Prøv igen",
        "store.Loja deletada com sucesso": "Butik slettet med succes",
        "store.Erro ao deletar loja. Tente novamente mais tarde":
        "Fejl ved sletning af butik. Prøv igen senere",
        "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "DER ER ENDNU INGEN REGISTREREDE BUTIKKER :(",
        "store.EXCLUIR LOJA": "SLET BUTIK",
        "store.Você deseja excluir a loja da plataforma IOK?": "Ønsker du at slette butikken fra IOK-platformen?",
        "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "Hvis du gør dette, vil det tilknyttede udstyr ikke længere være knyttet til nogen butik, medmindre du tilknytter det igen.",
        "store.loja editada com sucesso": "Butik redigeret med succes",
        "store.não foi possível editar a loja. Tente novamente mais tarde": "Butikken kunne ikke redigeres. Prøv igen senere",
        "store.editar loja": "rediger butik",
        "store.Procurar grupo de equipamentos": "Søg efter udstyrsgruppe",
        "store.cadastrar grupo": "registrer gruppe",
        "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "DER ER ENDNU INGEN REGISTREREDE GRUPPER :(",
        "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Klik på knappen øverst til højre for at tilføje grupper.",
        "store.cadastrar grupo de equipamentos": "registrer udstyrsgruppe",
        "store.grupo de equipamentos cadastrado com sucesso!": "Udstyrsgruppe registreret med succes!",
        "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "Gruppen kunne ikke registreres. Prøv igen senere",
        "store.Nome do grupo": "Gruppenavn",
        "store.informe o nome do grupo": "Angiv gruppens navn",
        "store.preencha o nome do grupo": "Udfyld gruppens navn",
        "store.Grupo de equipamentos deletado com sucesso!": "Udstyrsgruppe slettet med succes!",
        "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Fejl ved sletning af gruppen. Prøv igen senere",
        "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "SLET UDSTYRSGRUPPE",
        "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Ønsker du at slette denne udstyrsgruppe fra IOK-platformen?",
        "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "Hvis du gør dette, vil det tilknyttede udstyr ikke længere være knyttet til nogen gruppe, medmindre du tilknytter det igen.",
        "store.grupo de equipamentos editado com sucesso!": "Udstyrsgruppe redigeret med succes!",
        "store.não foi possível editar o grupo. Tente novamente mais tarde": "Gruppen kunne ikke redigeres. Prøv igen senere",
        "store.editar grupo de equipamentos": "rediger udstyrsgruppe",
        "store.CEP não encontrado no Brasil": "Postnummer blev ikke fundet i Brasilien",
        "store.Cadastrar": "Registrer",
        "store.Equipamentos vinculados": "Tilknyttet udstyr",
        
        // NAVBAR
        "navbar.home": "hjem",
        "navbar.cookbook": "cookbook",
        "navbar.my menus": "mine menuer",
        "navbar.equipment": "udstyr",
        "navbar.users": "brugere",
        "navbar.calls": "serviceanmodninger",
        "navbar.settings": "indstillinger",
        "navbar.help": "hjælp",
        "navbar.logout": "Log ud",
        "navbar.Editar conta": "Rediger konto",
        "navbar.API Externa": "Ekstern API",
        "navbar.companhias": "virksomheder",
        "navbar.information": "IOK-information",
        
        // FOOTERBAR
        "footerBar.menu": "Menu",
        "footerBar.cookbook": "Cookbook",
        "footerBar.home": "Hjem",
        "footerBar.menus": "Menuer",
        "footerBar.notifications": "Notifikationer",
        
        //ATENDIMENTOS
        "calls.ATENDIMENTOS EM ABERTO": "ÅBNE SERVICEANMODNINGER",
        "calls.ATENDIMENTOS ENCERRADOS": "AFSLUTTEDE SERVICEANMODNINGER",
        
        //MAP
        "map.título": "Placering",
        "map.erro": "fejl!",
        "map.mensagem de erro": "kortet kunne ikke indlæses.",
        "map.Localização não disponível": "Placering ikke tilgængelig",
        
        //MODAL
        "modal.CONFIRMAR": "BEKRÆFT",
        "modal.Salvar alterações": "Gem ændringer",
        "Modal.Há alterações não salvas nos parâmetros dos passos ":
        "Der er ændringer i trinparametrene, som ikke er gemt ",
        "Modal.Como deseja proceder?": "Hvordan ønsker du at fortsætte?",
        "Modal.Avaliar alterações realizadas": "Gennemgå de foretagne ændringer",
        "Modal.Descartar alterações": "Kassér ændringer",
        
        //USUÁRIOS
        "user.Nome": "Navn",
        "user.E-mail": "E-mail",
        "user.Permissão": "Tilladelse",
        "user.Loja": "Butik",
        "user.Status": "Status",
        "user.Excluir": "Slet",
        "user.Editar": "Rediger",
        "user.Procurar usuário": "Søg efter bruger",
        "user.ADICIONAR USUÁRIO": "TILFØJ BRUGER",
        "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "DER ER ENDNU INGEN REGISTREREDE BRUGERE :(",
        "user.+ Usuário": "+ Bruger",
        "user.Informe o nome do usuário": "Angiv brugerens navn",
        "user.Preencha o nome do usuário": "Udfyld brugerens navn",
        "user.Informe o e-mail do usuário": "Angiv brugerens e-mail",
        "user.Preencha com um e-mail válido": "Indtast en gyldig e-mail",
        "user.Administrador": "Administrator",
        "user.Usuário": "Bruger",
        "user.Preencha o telefone do usuário": "Udfyld brugerens telefonnummer",
        "user.Selecione a permissão do usuário": "Vælg brugerens tilladelse",
        "user.Ativo": "Aktiv",
        "user.Inativo": "Inaktiv",
        "user.Usuário deletado da plataforma com sucesso!": "Brugeren blev slettet fra platformen!",
        "user.Ocorreu um erro. Tente novamente mais tarde": "Der opstod en fejl. Prøv igen senere",
        "user.EXCLUIR USUÁRIO": "SLET BRUGER",
        "user.delete.paragrafo 1": "Ønsker du at slette brugeren fra IOK-platformen?",
        "user.delete.paragrafo 2": "Hvis du gør dette, mister brugeren adgangen til alle platformens funktioner, medmindre vedkommende tilføjes igen ved at følge registreringsvejledningen.",
        "user.EDITAR USUÁRIO": "REDIGER BRUGER",
        "user.Usuário editado com sucesso!": "Brugeren blev redigeret!",
        "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "Denne bruger kunne ikke redigeres. Prøv venligst igen senere",
        "user.INFORMAÇÕES DO USUÁRIO": "BRUGEROPLYSNINGER",
        "user.Telefone": "Telefon",
        "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "Denne bruger kunne ikke registreres. Prøv venligst igen senere",
        "user.Usuário adicionado com sucesso!": "Bruger tilføjet med succes!",
        "user.CRIAR TIPO DE USUÁRIO": "OPRET BRUGERTYPE",
        "user.Criar novo tipo de usuário": "Opret ny brugertype",
        "user.Adicionar novo usuário": "Tilføj ny bruger",
        "user.Permissões": "Tilladelser",
        "user.Preencha o nome do novo tipo de usuário": "Udfyld navnet på den nye brugertype",
        "user.Selecione pelo menos uma permissão": "Vælg mindst én tilladelse",
        "user.Não foi possível carregar as permissões": "Tilladelserne kunne ikke indlæses",
        "user.Tipo de usuário criado com sucesso!": "Brugertype oprettet med succes!",
        "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "Denne nye brugertype kunne ikke oprettes. Prøv venligst igen senere",
        "user.Não foi possível carregar os tipos de usuário da companhia": "Virksomhedens brugertyper kunne ikke indlæses",
        "user.Tipo de usuário": "Brugertype",
        "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "E-mailadressen er allerede registreret på platformen. Angiv en ny e-mailadresse",
        "user.UNIR CONTAS": "FLET KONTOER",
        "user.ID da companhia": "Virksomheds-ID",
        "user.Digite o ID da companhia que deseja unir a sua conta": "Indtast ID'et for den virksomhed, du ønsker at knytte til din konto",
        "user.Preencha o ID da companhia": "Udfyld virksomheds-ID'et",
        "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "Administratoren af den anden konto kan finde ID'et ved at klikke på sit brugernavn i den øverste menu i højre side af skærmen.",
        "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!": "Administratoren af den anden konto vil modtage en e-mail for at acceptere din anmodning. Så snart den er accepteret, bliver de to konti flettet!",
        "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Det var ikke muligt at anmode om kontofletning. Bekræft venligst ID'et, eller prøv igen senere",
        "user.SOLICITAÇÃO APROVADA COM SUCESSO": "ANMODNING GODKENDT",
        "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "VENT VENLIGST, MENS VI FLETTER KONTOERNE. DENNE PROCES KAN TAGE ET PAR MINUTTER...",
        "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "KONTOFLETNINGEN ER GENNEMFØRT! KLIK PÅ KNAPPEN NEDENFOR FOR AT FÅ ADGANG TIL PLATFORMEN.",
        "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.": "VI KUNNE IKKE GENNEMFØRE KONTOFLETNINGEN. PRØV VENLIGST IGEN. HVIS PROBLEMET FORTSÆTTER, BEDES DU KONTAKTE VORES SUPPORT.",
        "user.possui todos os acessos": "har alle adgangsrettigheder",
        "user.possui o acesso das abas cookbook, meus menus e equipamentos": "har adgang til fanerne Cookbook, Mine menuer og Udstyr",
        "user.possui apenas o acesso da aba cookbook": "har kun adgang til fanen Cookbook",
        "user.possui apenas o acesso da aba equipamentos": "har kun adgang til fanen Udstyr",
        "user.possui apenas o acesso da aba meus menus": "har kun adgang til fanen Mine menuer",
        "user.Grupo de equipamentos": "Udstyrsgruppe",
        "user.Informe o telefone do usuário": "Angiv brugerens telefonnummer",
        "user.Nenhum grupo criado": "Ingen gruppe oprettet",
        "user.Digite o ID da companhia que terá acesso à sua conta": "Indtast ID'et for den virksomhed, som skal have adgang til din konto",
        "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.":
        "Når du angiver et ID for at flette konti med din virksomhed, skal du være opmærksom på, at den nye bruger også bliver administrator af din virksomheds konto. Bemærk desuden, at når en bruger accepterer at flette konti med din virksomhed, vil den virksomhed, som vedkommende tilhører, ophøre med at eksistere.",
        "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Eksempel: Din konto: 001 | Anden konto: 111. Efter kontofletningen bliver den anden konto til 001.",
        "user.Tela de Equipamentos": "Udstyrsskærm",
        "user.Tela de Meus Menus": "Skærmen Mine menuer",
        "user.Tela do Cookbook": "Cookbook-skærm",
        "user.Tela de Usuários": "Brugerskærm",
        "user.Aba de Suporte": "Supportfane",
        "user.Usuário Comum": "Standardbruger",
        "user.Usuário do Cookbook": "Cookbook-bruger",
        "user.Usuário de Equipamentos": "Udstyrsbruger",
        "user.Usuário de Meus Menus": "Bruger af Mine menuer",
        "user.Você deseja excluir seu acesso da plataforma IOK?": "Ønsker du at fjerne din adgang til IOK-platformen?",
        "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "Hvis du gør dette, mister du adgangen til alle platformens funktioner. For at få adgang igen skal du tilføjes til platformen på ny.",
        "user.CONFIRMAÇÃO": "BEKRÆFTELSE",
        "user.Confirme sua senha": "Bekræft din adgangskode",
        "user.Senha incorreta": "Forkert adgangskode",
        "user.Os equipamentos e menus criados por ele serão transferidos para o seu nome.": "Det udstyr og de menuer, som er oprettet af denne bruger, overføres til dit navn.",
        
        //TUTORIAIS 
        "tutorial.Fechar": "Luk",
        "tutorial.Fim": "Afslut",
        "tutorial.Próximo": "Næste",
        "tutorial.Abrir": "Åbn",
        "tutorial.Pular tutorial": "Spring vejledningen over",
        "tutorial.Editar detalhes da receita": "Rediger opskriftsdetaljer",
        "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Nu kan du tilføje flere detaljer til dine opskrifter og gøre dem endnu mere komplette. Klik på Rediger detaljer, og udfyld de nødvendige oplysninger.",
        "tutorial.Salvar edição da receita": "Gem redigering af opskrift",
        "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "Når du har tilføjet flere detaljer om opskriften, skal du klikke på Gem.",
        "tutorial.Editar registro de um equipamento": "Rediger udstyrsregistrering",
        "tutorial.Para completar o registro de seus equipamentos, abra o sidemenu, clique em Editar e preencha as informações de Categoria e Loja.": "For at fuldføre registreringen af dit udstyr skal du åbne sidemenuen, klikke på Rediger og udfylde oplysningerne om Kategori og Butik.",
        "tutorial.Editar usuário": "Rediger bruger",
        "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "For at fuldføre registreringen af brugere skal du åbne sidemenuen, klikke på Rediger og udfylde oplysningerne om den butik, som brugeren tilhører.",
        "tutorial.Salvar edições de um equipamento": "Gem ændringer af udstyr",
        "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "Når du har fuldført registreringen af dit udstyr, skal du klikke på Gem.",
        "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Når du klikker på rækken for et udstyr, der er registreret i en butik, kan du se flere statistikker og oplysninger om det samt anmode om service eller sende opdateringer.",
        "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "For at se flere oplysninger om butikken, såsom placering og de mest tilberedte opskrifter, skal du klikke på rækken for den enhed, du vil analysere.",
        "tutorial.Criar receita": "Opret opskrift",
        "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "I Cookbook kan du oprette dine egne opskrifter! Klik på Opret opskrift, og udfyld alle de nødvendige oplysninger.",
"tutorial.Editar ou excluir um usuário": "Rediger eller slet en bruger",
"tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "For at slette eller redigere oplysningerne om en allerede registreret bruger skal du klikke på sidemenuen og vælge den ønskede handling.",
"tutorial.Gerenciamento de usuários": "Brugeradministration",
"tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Her kan du nemt administrere dine brugere. Når du klikker på + Bruger, kan du tilføje en ny bruger eller oprette en ny brugertype.",
"tutorial.Suas receitas": "Dine opskrifter",
"tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "I Cookbook finder du også dine egne opskrifter, og du kan selvfølgelig også oprette nye! Klik på Gemte opskrifter for at se de opskrifter, der er gemt fra Práticas Cookbook, samt dem, du selv har oprettet.",
"tutorial.Filtros do Cookbook": "Cookbook-filtre",
"tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "For at gøre det nemmere at finde opskrifter kan du anvende filtre. Klik blot på det ønskede filter, og vælg en af mulighederne.",
"tutorial.Cookbook": "Cookbook",
"tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "I Cookbook under Tilgængelige opskrifter finder du opskrifter, som er udviklet af Práticas kokke, og du kan bruge dem, når du ønsker.",
"tutorial.Atualizar equipamentos": "Opdater udstyr",
"tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen-drev. Depois disso, clique em Confirmar.": "For at sende en opdatering til dit udstyr skal du klikke på Opdater udstyr, vælge de modeller, du vil opdatere, og vælge opdateringsmetoden – via Wi-Fi eller USB-drev. Klik derefter på Bekræft.",
"tutorial.Adicionar equipamento": "Tilføj udstyr",
"tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "For at tilføje et udstyr til din konto skal du klikke på Tilføj udstyr og udfylde oplysningerne i dialogboksen. Klik derefter på Gem.",
"tutorial.Editar equipamento": "Rediger udstyr",
"tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "For at frakoble et udstyr eller redigere dets oplysninger skal du klikke på sidemenuen og vælge den ønskede handling.",
"tutorial.Seus equipamentos": "Dit udstyr",
"tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Her kan du se alt det udstyr, der er registreret på din platform.",
"tutorial.Restaurar arquivos": "Gendan filer",
"tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "For at gendanne en slettet fil eller slette den permanent skal du klikke på sidemenuen og vælge den ønskede handling.",
"tutorial.Lixeira": "Papirkurv",
"tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "Slettede menuer opbevares i Papirkurven i 30 dage. Derefter slettes de permanent.",
"tutorial.Salvar edições de usuário": "Gem brugerændringer",
"tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "Når du har fuldført registreringen af brugerne, skal du klikke på Gem.",
"tutorial.Criar menu": "Opret menu",
"tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "For at oprette og tilpasse en menu skal du klikke på Opret menu og udfylde de nødvendige oplysninger i dialogboksen. Du kan redigere en menu når som helst.",
"tutorial.Importar menu": "Importér menu",
"tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo og versão do equipamento.": "For at importere en menu skal du klikke på Importér menu og vælge udstyrets model og version.",
"tutorial.Criar grupo": "Opret gruppe",
"tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "For at organisere dine opskrifter i grupper skal du klikke på Opret gruppe og udfylde de nødvendige oplysninger i dialogboksen.",
"tutorial.Tipos de usuário": "Brugertyper",
"tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Nu kan du også oprette brugertyper med specifikke tilladelser, så de passer bedre til din organisation.",
"tutorial.Gerenciamento de contas": "Kontoadministration",
"tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Hvis en anden i din organisation også har migreret virksomhedens hovedkonto, kan du sammenlægge de to konti her.",
"tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "For at fuldføre registreringen af dit udstyr skal du åbne sidemenuen, klikke på Rediger og udfylde gruppeoplysningerne.",
"tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "For at fuldføre registreringen af brugerne skal du åbne sidemenuen, klikke på Rediger og udfylde oplysningerne om den udstyrsgruppe, de tilhører.",
"tutorial.Grupos de equipamentos": "Udstyrsgrupper",
"tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "På fanen Grupper kan du se de registrerede grupper og det udstyr, der er fordelt mellem dem. Du kan også oprette nye grupper og redigere de eksisterende.",
"tutorial.Detalhes de grupos": "Gruppedetaljer",
"tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "For at se flere oplysninger om gruppen, såsom placering og de mest tilberedte opskrifter, skal du klikke på den række, du ønsker at analysere.",
"tutorial.Equipamentos em grupos": "Udstyr i grupper",
"tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Når du klikker på rækken for et udstyr, der er registreret i en gruppe, kan du se flere statistikker og oplysninger om det samt anmode om service eller sende opdateringer.",
"tutorial.Grupos": "Grupper",
"tutorial.Atualização e cache": "Opdatering og cache",
"tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "Klik her for at opdatere platformen og løse eventuelle cacheproblemer.",
"tutorial.Dados dos equipamentos": "Udstyrsdata",
"tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais executadas, limpezas realizadas e outros dados relevantes.": "Når du klikker på rækken for et udstyr, kan du se flere statistikker og oplysninger om det, såsom de mest tilberedte opskrifter, udførte rengøringer og andre relevante data.",
"tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "For at ændre sproget på din platform skal du klikke på Sprog og vælge det ønskede sprog.",
"tutorial.Alterar idioma": "Skift sprog",
"tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "For at redigere eller konfigurere din konto skal du klikke på dit navn og vælge den ønskede mulighed.",
"tutorial.Editar conta": "Rediger konto",
"tutorial.Total de Usuários Cadastrados em sua conta.": "Samlet antal brugere registreret på din konto.",
"tutorial.Home": "Hjem",
        "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Placeringen af dit udstyr, med mulighed for at udvide kortet for bedre visning;",
"tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Opdateringer vedrørende versionerne af det udstyr, der er knyttet til din konto;",
"tutorial.Total de Receitas Cadastradas;": "Samlet antal registrerede opskrifter;",
"tutorial.Menus Disponíveis;": "Tilgængelige menuer;",
"tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;": "Dette er din startside! Her finder du en generel oversigt over din konto;",
"tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Klik på menufanerne for at udforske platformen og se alt, hvad den har at tilbyde.",
"tutorial.Exportar menu": "Eksportér menu",
"tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por USB-drev.": "Når du har tilpasset din menu, kan du eksportere den til dit udstyr via internettet eller et USB-drev.",
"tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "På fanen Placering kan du se de allerede registrerede adresser samt oprette præcise placeringer og knytte dit udstyr til dem.",
"tutorial.Localização": "Placering",
"tutorial.Informações sobre o equipamento": "Oplysninger om udstyret",
"tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;": "Tilsluttet udstyr og hvor mange der sender brugsdata;",
        
        //RECOVER ACCOUNT
"recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "For at fortsætte skal du vælge den kategori, du tilhører:",
"recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "Ønsker du at få adgang til platformen som DISTRIBUTØR? Opret din konto ved at klikke på VIRKSOMHED, og kontakt os, så vi kan aktivere de øvrige adgangsrettigheder.",
"recoverAccount.A qual organização você pertence": "Hvilken organisation tilhører du?",
        
        //RECOVER PASSWORD PAGE
"recoverPassword.E-mail para recuperação de senha": "E-mail til gendannelse af adgangskode",
"recoverPassword.Informe o e-mail cadastrado na plataforma": "Indtast den e-mailadresse, der er registreret på platformen",
"recoverPassword.E-mail inválido. Por favor, verifique": "Ugyldig e-mailadresse. Kontroller venligst",
"recoverPassword.RECUPERAR SENHA": "GENDAN ADGANGSKODE",
"recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA": "DU VIL SNART MODTAGE EN E-MAIL MED ET LINK TIL GENDANNELSE AF ADGANGSKODEN",
"recoverPassword.Informe seu e-mail": "Indtast din e-mailadresse",
"recoverPassword.Crie uma nova senha": "Opret en ny adgangskode",
"recoverPassword.O campo senha deve conter no mínimo 6 caracteres": "Adgangskoden skal indeholde mindst 6 tegn",
"recoverPassword.Confirme sua senha": "Bekræft din adgangskode",
"recoverPassword.As senhas devem ser iguais": "Adgangskoderne skal være ens",
"recoverPassword.ENTRAR": "LOG IND",
"recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "DU VIL SNART MODTAGE EN E-MAIL FOR AT BEKRÆFTE DIN IDENTITET",
"recoverPassword.CONTINUAR": "FORTSÆT",
"recoverPassword.CONFIRMAR": "BEKRÆFT",
"recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "Af sikkerhedshensyn er adgangen til kontoen blevet blokeret på grund af forkerte loginforsøg.",
"recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "For at låse din konto op skal du følge instruktionerne efter at have klikket på knappen nedenfor:",
"recoverPassword.Desbloquear conta": "Lås konto op",
"recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "Du har modtaget en e-mail for at starte oplåsningen af din konto.",
"recoverPassword.Verifique sua caixa de entrada ou spam.": "Kontrollér din indbakke eller spammappe.",
"recoverPassword.Verifique seu e-mail": "Kontrollér din e-mail",
"recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Indtast din login-e-mail, og opret en ny adgangskode for at få adgang til din konto.",
        
        
        
        
        
        
        // EXPORT
"export.Limpezas": "Rengøringer",
"export.Eventos": "Hændelser",
"export.Lista de receitas preparadas": "Liste over udførte opskrifter",
"export.Lista de limpezas realizadas": "Liste over udførte rengøringer",
"export.Lista de eventos ocorridos": "Liste over registrerede hændelser",
"export.Exportar dados": "Eksportér data",
"export.Exportar": "Eksportér",
"export.Informações do equipamento": "Udstyrsoplysninger",
"export.Dados exportados com sucesso!": "Data blev eksporteret!",
"export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Data kunne ikke eksporteres. Prøv venligst igen senere.",
"export.Detalhes do menu": "Menuoplysninger",
"export.Detalhes de receitas": "Opskriftsdetaljer",
"export.Detalhes e Passos": "Detaljer og trin",
"export.Exportando dados. Em breve o arquivo estará disponível!": "Eksporterer data. Filen vil snart være tilgængelig!",
"export.Resumo dos passos": "Oversigt over trin",
"export.salvar imagem": "gem billede",
"export.Nenhum modelo foi selecionado": "Ingen model er valgt",
        
        // COMPANIES PAGE
"company.Procurar companhia": "Søg efter virksomhed",
"company.Adicionar companhia": "Tilføj virksomhed",
"company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "DER ER ENDNU INGEN REGISTREREDE VIRKSOMHEDER :(",
"company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Klik på knappen i øverste højre hjørne for at tilføje virksomheder.",
"company.Adicionar": "Tilføj",
"company.ADICIONAR EQUIPAMENTOS": "TILFØJ UDSTYR",
"company.Preencha pelo menos um número de série": "Udfyld mindst ét serienummer",
"company.Informe os números de série": "Indtast serienumrene",
"company.Número de série": "Serienummer",
"company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "For at tilføje flere enheder skal du adskille dem med semikolon (;).",
"company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Indtast serienummeret på det udstyr, du vil tilføje, nedenfor.",
"company.Números de série adicionados com sucesso!": "Serienumrene blev tilføjet!",
"company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Serienumrene kunne ikke tilføjes. Prøv venligst igen senere.",
"company.adicionar": "tilføj",
"company.Procurar por companhia ou ID": "Søg efter virksomhed eller ID",
"company.Companhia": "Virksomhed",
"company.E-mail principal": "Primær e-mail",
"company.Local": "Lokation",
"company.Companhia adicionada com sucesso!": "Virksomheden blev tilføjet!",
"company.Não foi possível cadastrar a companhia": "Virksomheden kunne ikke registreres",
"company.REMOVER COMPANHIA": "FJERN VIRKSOMHED",
"company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Vil du fjerne virksomheden permanent? Det udstyr, der er knyttet til den, vil også blive fjernet fra din konto.",
"company.Esta ação não poderá ser desfeita.": "Denne handling kan ikke fortrydes.",
"company.A companhia foi removida com sucesso!": "Virksomheden blev fjernet!",
"company.Não foi possível remover a companhia": "Virksomheden kunne ikke fjernes",
"company.Quant. de fornos": "Antal ovne",
"company.Fornos conectados": "Tilsluttede ovne",
"company.Fornos não conectados": "Ikke-tilsluttede ovne",
"company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "DER ER ENDNU INTET REGISTRERET UDSTYR :(",
"company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Klik på knappen i øverste højre hjørne for at tilføje udstyr.",
"company.Procurar número de série": "Søg efter serienummer",
"company.excluir equipamento": "slet udstyr",
"company.Você deseja excluir o equipamento selecionado definitivamente?": "Vil du slette det valgte udstyr permanent?",
"company.Número de série editado com sucesso!": "Serienummeret blev redigeret!",
"company.Não foi possível editar o número de série. Tente novamente mais tarde": "Serienummeret kunne ikke redigeres. Prøv venligst igen senere.",
"company.Informe o número de série": "Indtast serienummeret",
"company.Preencha um número de série": "Udfyld et serienummer",
"company.EDITAR EQUIPAMENTO": "REDIGER UDSTYR",
"company.Modelo": "Model",
"company.Cadastro": "Registrering",
"company.Conectado": "Tilsluttet",
"company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "VÆLG UDSTYR, DER SKAL SLETTES",
"company.O equipamento foi removida com sucesso!": "Udstyret blev fjernet!",
"company.Não foi possível remover o equipamento": "Udstyret kunne ikke fjernes",
"company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "Specialtegn er ikke tilladt, undtagen semikolon (';')",
"company.Preencha o número de série sem caracteres especiais": "Indtast serienummeret uden specialtegn",
"company.Um ou mais números de série já estão provisionados para outra companhia": "Et eller flere serienumre er allerede tildelt en anden virksomhed.",
"company.Um ou mais números de série já estão conectados na conta de outra companhia": "Et eller flere serienumre er allerede tilknyttet en anden virksomheds konto.",
        
        // Error
"error.Ocorreu um erro ao carregar esta seção": "Der opstod en fejl ved indlæsning af denne sektion",
"error.Tentar novamente": "Prøv igen",
        
        //DASHBOARDS
"dashboard.fornos vinculados": "TILKNYTTEDE OVNE",
"dashboard.ativos": "Aktive",
"dashboard.inativos": "Inaktive",
"dashboard.sem status": "Ingen status",
"dashboard.fornos atualizados": "OPDATEREDE OVNE",
"dashboard.com a versão do software mais recente": "Med den nyeste softwareversion",
"dashboard.chamados": "SERVICESAGER",
"dashboard.veja mais no app cliente": "Se mere i Kunde-appen",
"dashboard.limpeza diária": "DAGLIG RENGØRING",
"dashboard.dos fornos estão em dia": "af ovnene er ajour",
"dashboard.top 3": "Top 3",
"dashboard.média de execuções de receitas por hora": "Gennemsnitligt antal opskrifter tilberedt pr. time",
"dashboard.avisos": "MEDDELELSER",
"dashboard.sem avisos por aqui": "INGEN MEDDELELSER HER",
"dashboard.ver mais": "Se mere",
"dashboard.abertos pela plataforma IOK": "Åbnet via IOK-platformen",
"dashboard.equipamentos": "Udstyr",
"dashboard.receitas": "Opskrifter",
"dashboard.executada": "tilberedt",
"dashboard.vezes": "gange",
"dashboard.forno": "Ovn",
"dashboard.média por hora": "Gennemsnit pr. time",
"dashboard.editar": "rediger",
"dashboard.endereço:": "Adresse:",
"dashboard.cep:": "Postnummer:",
"dashboard.estatísticas": "Statistik",
"dashboard.uso de equipamento": "Brug af udstyr",
"dashboard.pico de uso": "Spidsbelastning",
"dashboard.receitas mais executadas por equipamento": "Mest tilberedte opskrifter pr. udstyr",
"dashboard.recolher": "skjul",
"dashboard.TOROS TC CONECTADOS:": "TILSLUTTEDE TOROS TC:",
"dashboard.Consumo de energia - Lastro Toro TC": "Energiforbrug - Lastro Toro TC",
"dashboard.tootilp": "Summen af alle opskrifter, der er tilberedt på den aktuelle dag, divideret med det antal timer, ovnen har været tændt.",
"dashboard.noResults": "Ingen resultater fundet :(",
"dashboard.Preaquecimento": "Forvarmning",
"dashboard.Esfriamento": "Afkøling",
"dashboard.Execução de receitas": "Tilberedning af opskrifter",
"dashboard.Execução de receitas TSi": "TSi-opskriftstilberedning",
"dashboard.Modo manual": "Manuel tilstand",
"dashboard.Limpeza": "Rengøring",
"dashboard.Porta": "Dør",
"dashboard.Erros e alertas": "Fejl og advarsler",
"dashboard.Parâmetros": "Parametre",
"dashboard.SEM DADOS POR AQUI": "INGEN DATA HER",
"dashboard.AINDA SEM GRÁFICOS POR AQUI": "ENDNU INGEN GRAFER HER",
"dashboard.description.AINDA SEM GRÁFICOS POR AQUI": "Vælg elementer fra listen ved siden af for at generere grafer, eller klik på rækken for at se flere detaljer.",
        
        
        //INFORMAÇÕES IOK
"iokInformation.search.placeholder": "Søg efter artikel",
"iokInformation.article.openInHelpCenter": "Se artiklen i Hjælpecenteret",
"iokInformation.aboutPlatform.platformFeatures.title": "Platformen og dens funktioner",
"iokInformation.aboutPlatform.platformFeatures.linkLabel": "Download den komplette præsentation",
"iokInformation.aboutPlatform.manual.title": "Brugervejledning",
"iokInformation.aboutPlatform.manual.linkLabel": "Download vejledning",
"iokInformation.aboutPlatform.privacy.title": "Privatlivspolitik",
"iokInformation.aboutPlatform.privacy.linkLabel": "Download politik",
"iokInformation.aboutPlatform.api.title": "Ekstern API",
"iokInformation.aboutPlatform.api.linkLabel": "Download dokument",
        
        //Telemetry TSI
"telemetry.EQUIPMENT_TURN_ON": "Udstyr tændt",
"telemetry.SENSORS_VALUES": "Sensorværdier",
"telemetry.ERROR_DETECTED": "Fejl registreret",
"telemetry.TIME_ADDED": "Tid tilføjet",
"telemetry.GN_ADDED": "GN tilføjet",
"telemetry.GN_RELEASED": "GN startet",
"telemetry.GN_FINISHED": "GN afsluttet",
        
"telemetry.HEAVY_CLEANING_CANCELED": "Kraftig rengøring annulleret",
"telemetry.CLEANING_CANCELED": "Rengøring annulleret",
"telemetry.CLEANING_RESTARTED": "Rengøring genstartet",
"telemetry.CLEANING_VAPORIZATION_STEP": "Fordampningstrin under rengøring",
"telemetry.CLEANING_SUPPLY_STEP": "Påfyldningstrin under rengøring",
"telemetry.CLEANING_CIRCULATION_STEP": "Cirkulationstrin under rengøring",
"telemetry.CLEANING_DEPLETION_STEP": "Tømningstrin under rengøring",
"telemetry.CLEANING_RISING_STEP": "Skylletrin under rengøring",
"telemetry.CLEANING_STARTED": "Rengøring startet",
"telemetry.CLEANING_FINISHED": "Rengøring afsluttet",
"telemetry.RECOMMENDED_CLEANING": "Rengøring anbefalet",
"telemetry.VALID_PASSWORD_CLEANING": "Gyldig adgangskode til rengøring",
"telemetry.INVALID_PASSWORD_CLEANING": "Ugyldig adgangskode til rengøring",
        
"telemetry.RECIPE_STARTED": "Opskrift startet",
"telemetry.RECIPE_FINISHED": "Opskrift afsluttet",
"telemetry.RECIPE_CANCELED": "Opskrift annulleret",
"telemetry.RECIPE_STEP_CHANGED": "Opskriftstrin ændret",
"telemetry.RECIPE_PAUSED": "Opskrift sat på pause",
"telemetry.RECIPE_RESUMED": "Opskrift genoptaget",
"telemetry.DROP_ENERGY_SUPPLY": "Genoptaget efter strømsvigt",
"telemetry.RESUME_RECIPE_CANCELED": "Genoptagelse af opskrift annulleret",
        
"telemetry.PRE_HEAT_STARTED": "Forvarmning startet",
"telemetry.PRE_HEAT_FINISHED": "Forvarmning afsluttet",
"telemetry.OPERATION_CONTINUE_STARTED": "Genoptagelse af drift startet",
"telemetry.OPERATION_CONTINUE_FINISHED": "Genoptagelse af drift afsluttet",
"telemetry.HOLD_TEMPERATURE_STARTED": "Hold temperatur startet",
"telemetry.HOLD_TEMPERATURE_FINISHED": "Hold temperatur afsluttet",
"telemetry.COOL_DOWN_STARTED": "Afkøling startet",
"telemetry.COOL_DOWN_FINISHED": "Afkøling afsluttet",
"telemetry.NOCTURNAL_COOKING_STARTED": "Nattilberedning startet",
"telemetry.NOCTURNAL_COOKING_FINISHED": "Nattilberedning afsluttet",
"telemetry.SEALING_STARTED": "Forsegling startet",
"telemetry.SEALING_FINISHED": "Forsegling afsluttet",
"telemetry.TURBO_GRILL_STARTED": "Turbo Grill startet",
"telemetry.TURBO_GRILL_FINISHED": "Turbo Grill afsluttet",
"telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill aktiveret",
"telemetry.TURBO_GRILL_DISABLED": "Turbo Grill deaktiveret",
        
"telemetry.MOISTURE_CHANGED": "Fugtighed ændret",
"telemetry.TURBINE_CHANGED": "Blæserværdi ændret",
"telemetry.SET_POINT_CHANGED": "Kammertemperatur ændret",
"telemetry.STEAM_CHANGED": "Damp ændret",
"telemetry.PROBE_CHANGED": "Sondetemperatur ændret",
"telemetry.TIME_CHANGED": "Tid ændret",
"telemetry.DOOR_OPENED": "Dør åbnet",
"telemetry.DOOR_CLOSED": "Dør lukket",
        
"telemetry.PROBE_CONTROL_SELECTED": "Sondestyring valgt",
"telemetry.TIME_CONTROL_SELECTED": "Tidsstyring valgt",
"telemetry.MANUAL_STEAM_INJECTED": "Manuel dampindsprøjtning",
"telemetry.AUTOMATIC_STEAM_INJECTED": "Automatisk dampindsprøjtning",
        
"telemetry.DATABASE_CREATED": "Database oprettet",
"telemetry.EXIT_FUNCTION": "Funktion afsluttet",
"telemetry.CONSUMPTION": "Forbrug",
"telemetry.STANDBY": "Standby",
        
"telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Analytics-fejl: Ugyldig anmodning",
"telemetry.ANALYTICS_ERROR_FORBIDDEN": "Analytics-fejl: Adgang nægtet",
"telemetry.ANALYTICS_ERROR_SERVER": "Analytics-fejl: Serverfejl",
"telemetry.ANALYTICS_ERROR_UNEXPECTED": "Analytics-fejl: Uventet fejl",
"telemetry.ANALYTICS_SUCCESS": "Analytics gennemført",
        
"telemetry.STEP": "Trin",
"telemetry.STEAM": "Damp",
"telemetry.PROBE": "Sonde",
"telemetry.TURBINE": "Blæser",
"telemetry.OCCURRENCES": "forekomst(er)",
"telemetry.FUNC_USER_RECIPE": "Brugeropskrift",
"telemetry.FUNC_TSI_RECIPE": "TSi-opskrift",
"telemetry.FUNC_DELTA_T": "Delta T",
"telemetry.FUNC_STEAM": "Damp",
"telemetry.FUNC_COMBINED_STEAM": "Kombineret damp",
"telemetry.FUNC_HOT_AIR": "Varm luft",
"telemetry.FUNC_NOCTURNAL_COOKING": "Nattilberedning",
"telemetry.FUNC_REGENERATE": "Regenerering",
"telemetry.FUNC_MULTIPLE_COOKING": "Flertrinstilberedning",
        
"haccp.filterBy": "Filtrer efter",
"haccp.export.generating": "HACCP-regnearket bliver genereret og vil automatisk blive downloadet om kort tid.",
"haccp.voltage": "Spænding",
"haccp.voltageReading": "Spændingsmåling",
"haccp.voltageOscillation": "Spændingsudsving i løbet af dagen",
"haccp.status.normal": "Normal",
"haccp.status.attention": "Advarsel",
"haccp.status.critical": "Kritisk",
"haccp.dateTime": "Dato/Tid",
"haccp.errorDetected": "Fejl/advarsel registreret",
"haccp.detected": "registreret",
"haccp.errorTypeLabel": "Fejl-/advarselstype",
"haccp.severityLabel": "Alvorlighed",
"haccp.severity.error": "Fejl",
"haccp.severity.alert": "Advarsel",
"haccp.error.canNetwork": "CAN-netværksfejl",
"haccp.error.chamberSensor": "Fejl på kammersensor",
"haccp.error.steamSensor": "Fejl på dampsensor",
"haccp.error.probeSensor": "Fejl på sonde",
"haccp.error.noWater": "Fejl: manglende vand",
"haccp.error.panelTemp": "Fejl: paneltemp.",
"haccp.error.motor": "Motorfejl",
"haccp.error.motorComm": "Motor kommunikationsfejl",
"haccp.error.hygieneIncomplete": "Fejl: ufuldstændig rengøring",
"haccp.error.familyModel": "Fejl: familie/model",
"haccp.error.boardTemp": "Fejl: printpladetemp.",
"haccp.error.energyModule": "Fejl: energimodul",
"haccp.error.i2c": "I2C-fejl",
"haccp.error.gas": "Gasfejl",
"haccp.loading": "Indlæser...",
"haccp.quantity": "Antal",
"haccp.executions": "Tilberedninger",
"haccp.manual.mode": "Tilstand",
"haccp.manual.tempC": "Temp. (°C)",
"haccp.manual.timeMin": "Tid (min)",
"haccp.manual.probeC": "Sonde (°C)",
"haccp.manual.steamPct": "Damp %",
"haccp.cleaning.label": "Rengøring",
"haccp.cleaning.recommendedLabel": "Anbefalet rengøring",
"haccp.cleaning.status.completed": "Fuldført",
"haccp.cleaning.status.restarted": "Genstartet",
"haccp.cleaning.status.interrupted": "Afbrydt",
"haccp.status.label": "Status",
"haccp.error": "Fejl",
"haccp.consumption.water": "Vandforbrug",
"haccp.consumption.energy": "Energiforbrug",
"haccp.short.temp": "Temp.",
"haccp.short.time": "Tid",
"haccp.day": "Dag",
"haccp.recipeExecutions": "Antal tilberedninger",
"STEAM": "Damp",
"COMBINED_STEAM": "Kombineret damp",
"PROBE": "Sonde",
"TURBINE": "Blæser",
"HOT_AIR": "Varm luft",
"NOCTURNAL_COOKING": "Nattilberedning",
"REGENERATE": "Regenerering",
"MULTIPLE_COOKING": "Flertrinstilberedning",
"DELTA_T": "Delta T",
        
        //CSAT
"csat.AVALIE SUA EXPERIÊNCIA": "VURDER DIN OPLEVELSE",
"csat.Como você avalia sua experiência com": "Hvordan vurderer du din oplevelse med",
"csat.Muito insatisfeito": "Meget utilfreds",
"csat.Insatisfeito": "Utilfreds",
"csat.Neutro": "Neutral",
"csat.Satisfeito": "Tilfreds",
"csat.Muito satisfeito": "Meget tilfreds",
"csat.Utilize o espaço abaixo para deixar suas sugestões:": "Brug feltet nedenfor til at skrive dine forslag:",
"csat.Digite aqui": "Skriv her",
"csat.Obrigado por responder à nossa pesquisa!": "Tak fordi du besvarede vores undersøgelse!",
"csat.Selecione uma nota para continuar": "Vælg en vurdering for at fortsætte",
"csat.Enviar": "Send",
"csat.a criação de receitas": "oprettelse af opskrifter",
"csat.o cadastro de equipamentos": "registrering af udstyr",
"csat.o cadastro de usuários": "registrering af brugere",
"csat.a criação de menus": "oprettelse af menuer",
"csat.a deleção de receitas": "sletning af opskrifter",
"csat.a reordenação de receitas": "omorganisering af opskrifter",
"csat.o envio de software": "afsendelse af software",
"csat.o envio de menus": "afsendelse af menuer",
"csat.o uso de receitas do Cookbook": "brug af opskrifter fra Cookbook",
        
        
    },
};

export default da;


